import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Container,
  Paper,
  Typography,
  TextField,
  Avatar,
  Autocomplete,
  Chip,
  CircularProgress,
  Stack,
  Grid,
  Button,
  Tabs,
  Tab,
  Divider,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  FormControl,
  InputLabel, 
  Select,
  MenuItem,
  TablePagination,
  TableContainer,
  FormControlLabel,
  Checkbox ,
  FormHelperText,
  Collapse
} from "@mui/material";
import {
  Person,
  Search,
  LocalHospital,
  Science,
  Notes,
  LocalPharmacy,
  CalendarMonth,
  Print,
  Send,
  History,
  Close,
  Scanner,
  Medication,
  RoomService,
  Hotel,
  PersonAdd ,
   AutoAwesome ,
   CameraAlt ,Delete,
   SwapHoriz,
} from "@mui/icons-material";

import "react-quill/dist/quill.snow.css";
import axios from "axios";
import { Tooltip } from "@mui/material";

import { suggestionsData } from "../../data/suggestionsData";

import SaveIcon from "@mui/icons-material/Save";
import { Edit } from "@mui/icons-material";
import { ErrorMessage, successMessage } from "../../Message";
import { loadAllInPatientsWard , loadInsuredServicesdb ,loadDoctorSuggestionsInpatient  ,loadPatientDiagnosisdb 
  ,servicesToday ,saveServiceProvideddb ,saveOrUpdateDiagnosisdb ,loadDiagnosisOptionsdb ,loadProcedureOptionsdb 
   , loadRBSHistorydb , saveRBSdb , deleteRBSdb ,loadWardsdb ,loadAvailableBedsdb  ,transferPatientWardBeddb ,loadPatientCurrentBeddb 
  ,loadOtherServicesdb ,requestOtherService ,loadRequestedOtherServicesInpatient ,saveAppointmentdb, 
  loadAppointmentsdb, updateAppointmentdb  ,loadWardRoundsdb ,deleteOrReverseOtherServicedb , loadFBSHistorydb , saveFBSdb ,deleteFBSdb ,
  inpatientStatsdb  ,loadNurseNotesdb ,saveNurseNotedb ,deleteNurseNotedb ,loadVitalsHistorydb, saveVitalsdb , deleteVitalsdb 
  ,loadPatientMedicationsForChartdb ,saveChartedMedicationdb ,loadChartedMedicationsdb, markMedicationAsServeddb ,  deleteChartedMedicationdb 
  ,loadAllInPatientsWardFiltered,getNurseAssignedWardsdb,
  transferERPatientdb
 }  from '../../BaseURL';

import ComplianceAlerts from '../../Compliance/ComplianceAlerts';
import ComplianceBanner from '../../Compliance/ComplianceBanner';
import ComplianceFollowupBell from '../../Compliance/ComplianceFollowupBell';
import ComplianceVitalsBackfill from '../../Compliance/ComplianceVitalsBackfill';
import ComplianceNotesBackfill from '../../Compliance/ComplianceNotesBackfill';

import LockIcon from "@mui/icons-material/Lock";
import Swal from "sweetalert2";
import { formatWithOutSom ,frequencyTimeMap ,getFrequencyTimes ,frequencyMap ,frequencyMultiplier ,resolveDoseOffsets} from "../../Message";
import MedicalHistoryDialog from "../../Doctors/MedicalHistoryDialog";
import LabHistoryDialog from "../../Doctors/LabHistoryDialog";
import ScanHistoryDialog from "../../Doctors/ScanHistoryDialog";
import MedicationHistory from "../../Pharmacy/MedicationHistory";
import VitalsHistoryDialog from "../../Doctors/VitalsHistoryDialog";
import MedicationSheetDialog from '../../Wards/MedicationSheetDialog';
import MedicationChartDialog from '../../Wards/MedicationChartDialog';
import InlineMedicationSheet from '../../Wards/InlineMedicationSheet';

import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import ScienceIcon from "@mui/icons-material/Science";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import TopicIcon from '@mui/icons-material/Topic';
import EditNoteIcon from '@mui/icons-material/EditNote';
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";

import SpecialPrecautionDialog from "../../Doctors/SpecialPrecautionDialog";
import moment from "moment";

import VitalsHistoryDialogAdmission from "../../Doctors/VitalsHistoryDialogAdmission";
import LabHistoryDialogAdmission from "../../Doctors/LabHistoryDialogAdmission";
import ScanHistoryDialogAdmission from "../../Doctors/ScanHistoryDialogAdmission";
import MedicalHistoryDialogAdmission from "../../Doctors/MedicationHistoryDialogAdmission";
import PatientTable from '../../Wards/PatientTable';
import { ArrowBack, ArrowBackIosNew, ArrowForwardIos, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { Fab } from '@mui/material';
import AINurseNoteDialog from '../../Common/AINurseNoteDialog';


const InPatient = () => {

   const [InpatientStats, setInpatientStats] = useState({
    totalOutpatients: 0,
    maleCount: 0,
    femaleCount: 0,
    pediatricsCount: 0,
    adultCount: 0
  });

  const currentDate = moment().format('YYYY-MM-DD');
  const [loading, setLoading] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [assignedWardIds, setAssignedWardIds] = useState('');
  const [complianceRefreshKey, setComplianceRefreshKey] = useState(0);

  
  const [allPatients ,setAllPatients] = useState([]);

  // When a caller (compliance FAB, follow-up bell) selects a patient AND
  // wants to land on a specific tab, set this ref to the tab name *before*
  // calling setSelectedPatient. The selectedPatient effect honors it
  // (instead of defaulting to tab 0) and then clears it.
  const pendingTabRef = useRef(null);

  // Auto-collapsing patient banner via IntersectionObserver on a sentinel —
  // see Wards/InPatient.js for the rationale. Cooldown prevents the layout
  // shift caused by the Collapse animation from immediately re-triggering
  // the observer (the previous scroll-listener bounced in/out for that
  // exact reason).
  const [bannerCollapsed, setBannerCollapsed] = useState(false);
  const [bannerManual, setBannerManual]       = useState(false);
  const bannerSentinelRef = useRef(null);
  const bannerCooldownRef = useRef(false);
  useEffect(() => {
    if (bannerManual) return;
    const el = bannerSentinelRef.current;
    if (!el || typeof IntersectionObserver === 'undefined') return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (bannerCooldownRef.current) return;
        bannerCooldownRef.current = true;
        setTimeout(() => { bannerCooldownRef.current = false; }, 350);
        setBannerCollapsed(!entry.isIntersecting);
      },
      { threshold: 0, rootMargin: '-80px 0px 0px 0px' }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [bannerManual, selectedPatient?.id]);
  useEffect(() => {
    setBannerCollapsed(false);
    setBannerManual(false);
  }, [selectedPatient?.id]);

const [serviceProvided, setServiceProvided] = useState('');
const [attendanceType, setAttendanceType] = useState('');


const [medHistoryOpen, setMedHistoryOpen] = useState(false);
const [labHistoryOpen, setlabHistoryOpen] = useState(false);
const [ScanHistoryOpen, setScanHistoryOpen] = useState(false);
const [openmedHis, setopenmedHis] = useState(false);
const [vitalsHistoryOpen, setVitalsHistoryOpen] = useState(false);
const [medSheetOpen, setMedSheetOpen] = useState(false);

const [precautionDialogOpen, setPrecautionDialogOpen] = useState(false);
const [complaint, setComplaint] = useState("");
const [history, setHistory] = useState("");
const [exam, setExam] = useState("");
const [other, setOther] = useState("");

const [detentionTimeLeft, setDetentionTimeLeft] = useState('');
const [erTimeElapsed, setErTimeElapsed] = useState('');

const [wards, setWards] = useState([]);
const [availableBeds, setAvailableBeds] = useState([]);
const [selectedWard, setSelectedWard] = useState(null);
const [selectedBed, setSelectedBed] = useState(null);
const [currentBedInfo, setCurrentBedInfo] = useState(null);
const [transferReason, setTransferReason] = useState('');
const [transferDialogOpen, setTransferDialogOpen] = useState(false);


useEffect(() => {
  if (!selectedPatient || selectedPatient.status !== 'Detention') {
    setDetentionTimeLeft('');
    return;
  }

  const calculateTimeLeft = () => {
    if (!selectedPatient.currtime) return '';

    const detentionStart = moment(selectedPatient.currtime);
    const now = moment();
    const detentionEnd = detentionStart.clone().add(30, 'hours');
    
    const hoursLeft = detentionEnd.diff(now, 'hours');
    const minutesLeft = detentionEnd.diff(now, 'minutes') % 60;

    if (hoursLeft < 0) {
      return 'EXPIRED';
    }

    return `${hoursLeft}h ${minutesLeft}m`;
  };

  // Calculate immediately
  setDetentionTimeLeft(calculateTimeLeft());

  // Update every minute
  const interval = setInterval(() => {
    setDetentionTimeLeft(calculateTimeLeft());
  }, 60000); // Update every 60 seconds

  return () => clearInterval(interval);
}, [selectedPatient]);


// ── ER count-up timer (Emergency patients only) ─────────────────────────
useEffect(() => {
  if (!selectedPatient || selectedPatient.status !== 'Emergency' || !selectedPatient.currtime) {
    setErTimeElapsed('');
    return;
  }

  const calcElapsed = () => {
    const start = moment(selectedPatient.currtime);
    const now = moment();
    const totalSeconds = Math.max(0, now.diff(start, 'seconds'));
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  };

  setErTimeElapsed(calcElapsed());
  const interval = setInterval(() => setErTimeElapsed(calcElapsed()), 1000);
  return () => clearInterval(interval);
}, [selectedPatient]);


// ── Patient navigation (prev / next within the worklist) ───────────────
// Index of the currently selected patient inside allPatients, -1 if not present
const currentPatientIndex = selectedPatient
  ? allPatients.findIndex(p => p.id === selectedPatient.id)
  : -1;
const hasPrevPatient = currentPatientIndex > 0;
const hasNextPatient = currentPatientIndex >= 0 && currentPatientIndex < allPatients.length - 1;
const goToPrevPatient = () => {
  if (hasPrevPatient) setSelectedPatient(allPatients[currentPatientIndex - 1]);
};
const goToNextPatient = () => {
  if (hasNextPatient) setSelectedPatient(allPatients[currentPatientIndex + 1]);
};

// Keyboard shortcuts: ← previous patient · → next patient
// Disabled while typing in inputs/textareas/selects so we don't hijack form input.
useEffect(() => {
  if (!selectedPatient) return;
  const onKey = (e) => {
    const tag = (e.target?.tagName || '').toLowerCase();
    const editable = e.target?.isContentEditable;
    if (tag === 'input' || tag === 'textarea' || tag === 'select' || editable) return;
    if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
    if (e.key === 'ArrowLeft')  { e.preventDefault(); goToPrevPatient(); }
    if (e.key === 'ArrowRight') { e.preventDefault(); goToNextPatient(); }
  };
  window.addEventListener('keydown', onKey);
  return () => window.removeEventListener('keydown', onKey);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [selectedPatient, allPatients]);


const ensureServiceAndAttendanceSelected = () => {
  if (!serviceProvided || !attendanceType) {
    Swal.fire({
      icon: "warning",
      title: "Missing Information",
      text: "Please select both 'Service Provided' and 'Type of Attendance' before proceeding.",
    });
    return false;
  }
  return true;
};


const [currentUser ,setcurrentUser]=useState()


const loadPatients = async () => {
  setLoading(true);
  try {
    const savedUser = localStorage.getItem('userInfo');
    const user = savedUser ? JSON.parse(savedUser) : null;

    const isAdmin = user?.role === 'System Administrator'
                 || user?.role === 'Head Of Assembly'
                 || user?.role === 'Head Of Department'
                 || user?.role === 'Doctor';

    let endpoint = loadAllInPatientsWardFiltered;  // filtered version
    let wardParam = '';

    // staffCode in nurse_ward_assignments references staff.trans_code,
    // and Login stores that as `trans_code` in localStorage.
    const staffCode = user?.trans_code;

    if (!isAdmin && staffCode) {
      // fetch this nurse's assigned wards
      const wardRes = await axios.get(getNurseAssignedWardsdb, {
        params: { staffCode }
      });

      if (wardRes.data.success && wardRes.data.results.length > 0) {
        wardParam = wardRes.data.results.map(w => w.ward_id).join(',');
      }
      // No rows → nurse has no ward restrictions → see all wards (default)
    }

    const response = await axios.get(endpoint, {
      params: {
        ...(wardParam ? { wardIds: wardParam } : {}),
        statusFilter: 'Emergency',  // ER tab → only emergency patients
      }
    });

    setAssignedWardIds(wardParam || '');

    if (response.data.success) {
      setAllPatients(response.data.results);
      setcurrentUser(user?.name || '');
    }
  } catch (error) {
    console.error('loadPatients failed:', error);
  } finally {
    setLoading(false);
  }
};


const [diagnosisOptions, setDiagnosisOptions] = useState([]);
const [procedureOptions ,setprocedureOptions]= useState([])


const loadDiagnosisOptions = async (age , gender , status)  => {
   setLoading(true);
  try {
    const response = await axios.get(loadDiagnosisOptionsdb, {
      params: {
        age: age,
        gender: gender ,
        status:status
      }
    });

    if (response.data.success) {
      setDiagnosisOptions(response.data.results);
    }
  } catch (error) {
    console.error('Error loading diagnosis options:', error);
  }finally {
    setLoading(false);
  }
};

const loadProcedureOptions = async (age , gender , status)  => {
 
   setLoading(true);
  try {
    const response = await axios.get(loadProcedureOptionsdb, {
      params: {
        age: age,
        gender: gender ,
        status:status
      }
    });

    if (response.data.success) {
      setprocedureOptions(response.data.results);
    }
  } catch (error) {
    console.error('Error loading diagnosis options:', error);
  }finally {
    setLoading(false);
  }
};

const loadOutpatientStats = async () => {
  try {
    const response = await axios.get(inpatientStatsdb);
    
    if (response.data.success) {
      setInpatientStats({
        totalOutpatients: response.data.total || 0,
        maleCount: response.data.male || 0,
        femaleCount: response.data.female || 0,
        pediatricsCount: response.data.pediatrics || 0,
        adultCount: response.data.adult || 0
      });
    }
  } catch (error) {
    console.error("Error loading outpatient stats:", error);
  }
}


useEffect(() => {
        
    loadPatients()
    loadOutpatientStats()
      
    const savedUserInfo = localStorage.getItem('userInfo');
      if (savedUserInfo) {
        const userInfo = JSON.parse(savedUserInfo);
        const userName = userInfo.name || ''; 
        setcurrentUser(userName)

         if (userName) loadDoctorSuggestions(userName);
      } 

}, []);


const [customSuggestions, setCustomSuggestions] = useState({});

const loadDoctorSuggestions = async (doctorName) => {
   setLoading(true);
  try {
    const response = await axios.get(loadDoctorSuggestionsInpatient, {
      params: { doctorName }
    });

    if (response.data.success) {
      setCustomSuggestions(response.data.data);


      Object.keys(response.data.data).forEach((field) => {
        const backendItems = response.data.data[field] || [];
        const merged = [
          ...new Set([...backendItems, ...suggestionsData[field]])
        ];
        suggestionsData[field] = merged;
      });

      console.log("Updated suggestionsData with backend doctor data:", suggestionsData);
    }
  } catch (error) {
    console.error("Error loading doctor suggestions:", error);
  }finally {
    setLoading(false);
  }
};

const loadServiceAndAttendance = async (patientId , dat) => {
 setLoading(true);
  try {
    const response = await axios.get(servicesToday, {
      params: { patient_id: patientId , dat:dat }
    });

    if (response.data.success && response.data.data) {
      const { name, att } = response.data.data;
      setServiceProvided(name || '');
      setAttendanceType(att || '');
    } else {
      setServiceProvided('');
      setAttendanceType('');
    }
  } catch (error) {
    console.error('Error loading service and attendance:', error);
  }finally {
    setLoading(false);
  }
};


const [insuredServices, setInsuredServices] = useState([]);

const loadInsuredServices = async (insuranceName, patientAge) => {
  setLoading(true);
  try {
  
    const response = await axios.get(loadInsuredServicesdb, {
      params: {
        STATUS: insuranceName,
        charge_status: "Main Services",
        patientAge: patientAge,
      },
    });

    if (response.data.success) {
      setInsuredServices(response.data.results);
      console.log("Loaded insured services:", response.data.results);
    } else {
      setInsuredServices([]);
    }
  } catch (error) {
    Swal.fire({
      title: "Error",
      text: error.response?.data?.message || "Failed to load insured services",
      icon: "error",
    });
  }finally {
    setLoading(false);
  }
};


useEffect(() => {
  if (selectedPatient) {
    if (pendingTabRef.current) {
      setActiveTab(pendingTabRef.current === 'vitals' ? 3 : 2);
      pendingTabRef.current = null;
    } else {
      setActiveTab(0);
    }
    loadInsuredServices(selectedPatient.insurance, selectedPatient.age);
    loadPatientDiagnosis(selectedPatient.id, selectedPatient.visitDate);
    loadServiceAndAttendance(selectedPatient.id, selectedPatient.visitDate);
    loadDiagnosisOptions(selectedPatient.age, selectedPatient.gender, selectedPatient.insurance);
    loadProcedureOptions(selectedPatient.age, selectedPatient.gender, selectedPatient.insurance);
  
    loadOtherServices();
    loadrequestedServices();
    loadWardRoundsData();
    loadNurseNotes(); 
    loadVitalsHistory()
     loadFBSHistory();  
    loadRBSHistory();

    loadPatientMedicationsForChart();
    loadChartedMedications();

     loadPatientCurrentBed();
     

    if (selectedPatient.PrecautionType && selectedPatient.PrecautionType.trim() !== '') {
      setPrecautionDialogOpen(true);
    }
  }
}, [selectedPatient]);


useEffect(() => {
  if (
    selectedPatient &&
    selectedPatient.id &&
    diagnosisOptions.length > 0 &&
    procedureOptions.length > 0 &&
    hasLoadedDiagnosis === false
  ) {
    loadPatientDiagnosis(selectedPatient.id ,selectedPatient.visitDate);
  }
}, [diagnosisOptions, procedureOptions]);


const [hasLoadedDiagnosis, setHasLoadedDiagnosis] = useState(false);
const [hasEdited, setHasEdited] = useState(false);
const [admmission_note, setadmmission_note] = useState();
const [admiAT, setadmiAT] = useState();
const [admit_by, setadmit_by] = useState();
const [Diagnosis, setDiagnosis] = useState();
const [procedure_, setprocedure_] = useState();

const loadPatientDiagnosis = async (patientId, dat) => {
  setLoading(true);
 
  try {
    const response = await axios.get(loadPatientDiagnosisdb, {
      params: { patientId, dat },
    });

    if (!response.data.success || !response.data.data) return;

    const { complaint, history, exam, other, documenting, procedure_ ,admmission_note ,admit_by ,time_admit} =
      response.data.data;

    setComplaint(complaint || "");
    setHistory(history || "");
    setExam(exam || "");
    setOther(other || "");
    setDiagnosis(documenting);
    setprocedure_(procedure_);
    setadmmission_note(admmission_note)
    setadmiAT(time_admit)
    setadmit_by(admit_by)
   
    if (documenting && documenting.trim() !== "") {
      const parsedDiagnosisNames = documenting
        .split(",")
        .map((item) => item.trim())
        .filter(name => name.length > 0);

      const matchedDiagnosis = diagnosisOptions.filter((opt) =>
        parsedDiagnosisNames.some(
          (parsedName) => opt.name.toLowerCase() === parsedName.toLowerCase()
        )
      );

     
      
      setSelectedDiagnoses(matchedDiagnosis);
    } else {
      setSelectedDiagnoses([]);
    }

   
    if (procedure_ && procedure_.trim() !== "") {
      const parsedProcedures = procedure_
        .split(",")
        .map((p) => p.trim())
        .filter(name => name.length > 0);

      const matchedProcedures = procedureOptions.filter((opt) =>
        parsedProcedures.some(
          (parsedName) => opt.name.toLowerCase() === parsedName.toLowerCase()
        )
      );

      setSelectedProcedures(matchedProcedures);
    } else {
      setSelectedProcedures([]);
    }

  
    setHasEdited(false);
  } catch (error) {
    console.error("Error loading diagnosis:", error);
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    if (!searchTerm || searchTerm.length < 1) {
      setSearchResults([]);
      setSearchOpen(false);
      return;
    }

    setSearchLoading(true);

    setTimeout(() => {
  const term = (searchTerm || "").toLowerCase();

  const results = allPatients.filter((p) => {
    const name = (p.fullName || "").toLowerCase();
    const id = (p.id || "").toLowerCase();
    const tel = p.tel || "";

    return (
      name.includes(term) ||
      id.includes(term) ||
      tel.includes(searchTerm)
    );
  });

  setSearchResults(results);
  setSearchOpen(true);
  setSearchLoading(false);
}, 300);

  }, [searchTerm]);

const saveServiceProvided = async (
  updateConfirmed = false,
  customType = null,
  customService = null
) => {
   setLoading(true);
  const finalAttendanceType = customType || attendanceType;
  const finalServiceProvided = customService || serviceProvided;

  const previousService = serviceProvided;
  const previousType = attendanceType;

  const selectedService = insuredServices.find(
    (s) => s.name === finalServiceProvided
  );

  try {
    const response = await axios.post(saveServiceProvideddb, {
      patient_id: selectedPatient.id,
      dat: selectedPatient.visitDate,
      service_name: finalServiceProvided,
      attendance_type: finalAttendanceType,
      insurance: selectedPatient.insurance,
      code: selectedService?.code || "",
      toup: selectedService?.toup || 0,
      amo: selectedService?.amo || 0,
      unin: selectedService?.unin || 0,
      currentUser,
      patientName: selectedPatient.fullName,
      updateConfirmed,
    });

    if (response.data.exists) {
      const result = await Swal.fire({
        title: "Update Today's Record?",
        text: `A record for '${finalServiceProvided}' (${finalAttendanceType}) already exists today. Do you want to update it?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, update it",
        cancelButtonText: "No, keep existing",
      });

      if (result.isConfirmed) {
        await saveServiceProvided(true, finalAttendanceType, finalServiceProvided);
      } else {
        setServiceProvided(previousService);
        setAttendanceType(previousType);

        Swal.fire(
          "No Changes Made",
          `Existing Type of Attendance kept (${previousType}).`,
          "info"
        );
      }

      return;
    }

    if (response.data.success) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message,
        timer: 1500,
        showConfirmButton: false,
      });
    }
  } catch (error) {
    console.error("Error saving service:", error);
    Swal.fire("Error", "Unable to save service information.", "error");
  }finally {
    setLoading(false);
  }
};

useEffect(() => {
  if (!selectedPatient || !hasLoadedDiagnosis || !hasEdited) return;
  if (!complaint && !history && !exam && !other) return;

  const timeout = setTimeout(async () => {
    try {
      await axios.post(saveOrUpdateDiagnosisdb, {
        patientId: selectedPatient.id,
        complaint,
        history,
        exam,
        other,
        doctor: currentUser,
      });
      console.log("Auto-saved diagnosis update");
    } catch (error) {
      console.error("Auto-save failed:", error);
    }
  }, 2000);

  return () => clearTimeout(timeout);
}, [complaint, history, exam, other, selectedPatient, hasLoadedDiagnosis, hasEdited]);






const [services, setservices] = useState([]);
const [serviceQuantities, setServiceQuantities] = useState({});

const loadOtherServices = async () => {
   setLoading(true);
  try {
    const response = await axios.get(loadOtherServicesdb, {
      params: {
        charge_status: "Manual",
      }
    });

    if (response.data.success) {
      setservices(response.data.results);
    } else {
      setservices([]);
    }

  } catch (error) {
    console.error("Failed to load other services:", error);
    setservices([]);
  }finally {
    setLoading(false);
  }
};


const [serviceSearchTerm, setServiceSearchTerm] = useState("");

const [requestedServices, setRequestedServices] = useState([]);

const loadrequestedServices = async () => {
   setLoading(false);
  try {
    const response = await axios.get(loadRequestedOtherServicesInpatient, {
      params: { patientId: selectedPatient.id , dat:selectedPatient.visitDate, currentDate }
    });

    if (response.data.success) {
      setRequestedServices(response.data.results);
    }
  } catch (err) {
    console.error("Error loading meds:", err);
  }finally {
    setLoading(false);
  }
};


const [servicePage, setServicePage] = useState(0);
const [serviceRowsPerPage, setServiceRowsPerPage] = useState(10);
const [reqServicePage, setReqServicePage] = useState(0);
const [reqServiceRowsPerPage, setReqServiceRowsPerPage] = useState(10);


const handleRequestService = async(srv) => {

  console.log(requestedServices)

    const alreadyRequested = requestedServices.some(
    (r) => r.service === srv.name && r.date == currentDate
  );


  if (alreadyRequested) {
    const result = await Swal.fire({
      title: "Duplicate Request",
      text: `${srv.name} has already been requested today. Do you want to request again?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Request Again",
      cancelButtonText: "No"
    });

    if (!result.isConfirmed) {
       setLoading(false);
      return;
    }
  }

   setLoading(true);
    try {
    const response = await axios.post(requestOtherService, {
      patientId: selectedPatient.id,
      dat:currentDate,
      charge: srv.name,
      amount: srv.amount,
      doc_name:currentUser,
      from_user:currentUser,
      name:selectedPatient.fullName,
      department:'Doctor'
    });

    if (response.data.success) {
      loadrequestedServices();
    }

  } catch (error) {
    ErrorMessage("Error", "Failed to request Non Insured Services ");
  }finally {
    setLoading(false);
  }

}; 


const handleDeleteServiceRequest = async (req) => {
 
   setLoading(true);
  const confirmDelete = await Swal.fire({
    title: "Delete Other Request?",
    text: `Are you sure you want to delete "${req.service}"?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
  });

  if (!confirmDelete.isConfirmed) {
    setLoading(false)
    return; 
  }

   try {
    const response = await axios.post(deleteOrReverseOtherServicedb, {
      patientId: selectedPatient.id,
      scanName: req.service,
      dat:currentDate,
      currentUser
    });

    if (response.data.reversal) {
      ErrorMessage("REVERSAL REQUIRED", response.data.reversal);
    } else {
      Swal.fire("Deleted", response.data.message, "success");
    }

    loadrequestedServices();

  } catch (error) {
    Swal.fire("Error", "Failed to delete Other request", "error");
  }finally {
    setLoading(false);
  }
};


const [editingAppointmentId, setEditingAppointmentId] = useState(null);

const [appointments, setAppointments] = useState([]);

const loadAppointments = async () => {
  try {
     setLoading(true);
    const response = await axios.get(loadAppointmentsdb, {
      params: { 
        patientId: selectedPatient?.id,
        doctorName: currentUser 
      }
    });

    if (response.data.success) {
      console.log(response.data.appointments)
      setAppointments(response.data.appointments || []);
    }
  } catch (error) {
    console.error("Error loading appointments:", error);
    ErrorMessage("Error", "Failed to load appointments");
  }finally {
    setLoading(false);
  }
};




const [selectedDiagnoses, setSelectedDiagnoses] = useState([]);
const [selectedProcedures, setSelectedProcedures] = useState([]);

const [admissionDate, setAdmissionDate] = useState(() => new Date().toISOString().split("T")[0]);
const [admissionTime, setAdmissionTime] = useState(() => {
  const now = new Date();
  return now.toTimeString().slice(0, 5);
});

const [wardRoundsData, setWardRoundsData] = useState([]);


const loadWardRoundsData = async () => {
  if (!selectedPatient) return;

  try {
    const res = await axios.get(loadWardRoundsdb, {
      params: {
        patientId: selectedPatient.id,
        startDate: selectedPatient.visitDate
      }
    });

    if (res.data.success) {
      setWardRoundsData(res.data.data);
    }
  } catch (error) {
    console.error("Error loading ward rounds:", error);
  }
};


const [nurseNotes, setNurseNotes] = useState([]);
const [selectedNote, setSelectedNote] = useState(null);
const [nurseNoteText, setNurseNoteText] = useState('');
const [aiNoteDialogOpen, setAiNoteDialogOpen] = useState(false);


const loadNurseNotes = async () => {
  if (!selectedPatient) return;
  
  setLoading(true);
  try {
    const response = await axios.get(loadNurseNotesdb, {
      params: {
        patientId: selectedPatient.id,
        visitDate: selectedPatient.visitDate
      }
    });

    if (response.data.success) {
      const notes = response.data.notes || [];
      setNurseNotes(notes);

      const todayNote = notes.find(
        note => note.user === currentUser && note.dat === currentDate
      );

      if (todayNote) {
        setSelectedNote(todayNote);
        setNurseNoteText(todayNote.note);
        
        console.log(`Auto-loaded your note for today (${currentDate})`);
      } else {
        handleClearNurseNote();
      }
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error("Error loading nurse notes:", error);
    ErrorMessage("Error", "Failed to load nurse notes");
  } finally {
    setLoading(false);
  }
};

const handleSelectNote = (note) => {
  setSelectedNote(note);
  setNurseNoteText(note.note);
};

const handleClearNurseNote = () => {
  setSelectedNote(null);
  setNurseNoteText('');
};

// Transfer the currently-selected ER patient to the regular Wards queue.
// Releases the ER bed but leaves patient.currtime untouched so the
// days-at-facility counter continues from the original ER admission.
const handleTransferToWard = async (patient) => {
  if (!patient?.id) return;

  const initials = (patient.fullName || '?')
    .split(/\s+/).filter(Boolean).slice(0, 2).map(s => s[0]).join('').toUpperCase();

  const ok = await Swal.fire({
    title: 'Transfer to Ward?',
    html: `
      <div style="text-align:left;font-family:Inter,Segoe UI,sans-serif;">
        <div style="display:flex;align-items:center;gap:12px;padding:12px;border:1px solid #e5e9ef;border-radius:10px;background:#f8fafc;">
          <div style="width:42px;height:42px;border-radius:50%;background:#dc2626;color:#fff;display:flex;align-items:center;justify-content:center;font-weight:800;">${initials}</div>
          <div style="flex:1;min-width:0;">
            <div style="font-weight:700;color:#0f172a;">${patient.fullName || ''}</div>
            <div style="color:#64748b;font-size:0.78rem;margin-top:2px;">ID: ${patient.id} · ${patient.age || '—'} yrs · ${patient.gender || ''}</div>
          </div>
        </div>
        <div style="margin-top:12px;padding:10px 12px;border-radius:8px;background:#DCFCE7;color:#15803D;font-size:0.85rem;font-weight:700;">
          ✓ The ER bed will be released.<br/>
          ✓ The patient will appear on the Wards pending queue as <strong>Transfer-Emergency</strong>.<br/>
          ✓ Days-at-facility counter continues from original admission (currtime is NOT reset).
        </div>
      </div>
    `,
    icon: undefined,
    showCancelButton: true,
    confirmButtonText: 'Yes, Transfer',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#1A9B7F',
    cancelButtonColor: '#64748b',
    width: 540,
    focusCancel: true,
  });
  if (!ok.isConfirmed) return;

  try {
    setLoading(true);
    const res = await axios.post(transferERPatientdb, {
      patientId:   patient.id,
      currentUser,
      name:        patient.fullName,
      age:         patient.age,
      gender:      patient.gender,
    });
    if (res.data?.success) {
      await Swal.fire({
        title: 'Transferred',
        text: 'Patient is now on the Wards pending queue.',
        icon: 'success',
        confirmButtonColor: '#1A9B7F',
        timer: 1800,
        showConfirmButton: false,
      });
      // Patient leaves the ER list; reload to drop them off-screen.
      setSelectedPatient(null);
      loadPatients();
    } else {
      throw new Error(res.data?.message || 'Transfer failed');
    }
  } catch (err) {
    console.error('transfer to ward failed', err);
    Swal.fire('Error', err.response?.data?.message || err.message || 'Could not transfer patient', 'error');
  } finally {
    setLoading(false);
  }
};

const handleSaveNurseNote = async () => {
  if (!nurseNoteText.trim()) {
    ErrorMessage("Error", "Please enter a note before saving");
    return;
  }

  const existingNoteToday = nurseNotes.find(
    note => note.user === currentUser && note.dat === currentDate
  );

  const confirmResult = await Swal.fire({
    title: existingNoteToday ? 'Update Today\'s Note?' : 'Save Note?',
    text: existingNoteToday 
      ? "This will update your existing note for today." 
      : "Do you want to save this nurse note?",
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: existingNoteToday ? 'Yes, Update' : 'Yes, Save',
    cancelButtonText: 'Cancel'
  });

  if (!confirmResult.isConfirmed) return;

  setLoading(true);
  try {
    const response = await axios.post(saveNurseNotedb, {
      patientId: selectedPatient.id,
      note: nurseNoteText,
      user: currentUser,
      name: selectedPatient.fullName,
      age: selectedPatient.age,
      gen: selectedPatient.gender,
      dat: currentDate,
      time: moment().format('HH:mm:ss')
    });

    if (response.data.success) {
      successMessage("Success", response.data.message);
      await loadNurseNotes();
      setComplianceRefreshKey(k => k + 1);
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error("Error saving nurse note:", error);
    ErrorMessage("Error", error.response?.data?.message || "Failed to save note");
  } finally {
    setLoading(false);
  }
};


const handleDeleteNurseNote = async (note) => {
  const confirmDelete = await Swal.fire({
    title: "Delete Note?",
    text: `Are you sure you want to delete your note from ${note.dat}?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6'
  });

  if (!confirmDelete.isConfirmed) return;

  setLoading(true);
  try {
    const response = await axios.post(deleteNurseNotedb, {
      patientId: selectedPatient.id,
      user: currentUser,
      dat: note.dat
    });

    if (response.data.success) {
      Swal.fire("Deleted", response.data.message, "success");
      loadNurseNotes();
      if (selectedNote?.trans_code === note.trans_code) {
        handleClearNurseNote();
      }
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error("Error deleting note:", error);
    ErrorMessage("Error", error.response?.data?.message || "Failed to delete note");
  } finally {
    setLoading(false);
  }
};


const [vitalsHistory, setVitalsHistory] = useState([]);
const [selectedVital, setSelectedVital] = useState(null);
const [vitalData, setVitalData] = useState({
  tem: '',
  pulse: '',
  res: '',
  pre: '',
  spo2: '',
  we: '',
  high: '',
  bmi: ''
});

const [vitalErrors, setVitalErrors] = useState({
  tem: false,
  pulse: false,
  res: false,
  pre: false,
  spo2: false,
  we: false
});


const loadVitalsHistory = async () => {
  if (!selectedPatient) return;
  
  setLoading(true);
  try {
    const response = await axios.get(loadVitalsHistorydb, {
      params: {
        patientId: selectedPatient.id,
        visitDate: selectedPatient.visitDate
      }
    });

    if (response.data.success) {
      const vitals = response.data.vitals || [];
      setVitalsHistory(vitals);
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error("Error loading vitals history:", error);
    ErrorMessage("Error", "Failed to load vitals history");
  } finally {
    setLoading(false);
  }
};

const handleSelectVital = (vital) => {
  setSelectedVital(vital);
  setVitalData({
    tem: vital.tem || '',
    pulse: vital.pulse || '',
    res: vital.res || '',
    pre: vital.pre || '',
    spo2: vital.spo2 || '',
    we: vital.we || '',
    high: vital.high || '',
    bmi: vital.bmi || ''
  });
};

const handleClearVitals = () => {
  setSelectedVital(null);
  setVitalData({
    tem: '',
    pulse: '',
    res: '',
    pre: '',
    spo2: '',
    we: '',
    high: '',
    bmi: ''
  });
  setVitalErrors({
    tem: false,
    pulse: false,
    res: false,
    pre: false,
    spo2: false,
    we: false
  });
};

const calculateBMI = (weight, height) => {
  if (!weight || !height || weight <= 0 || height <= 0) return '';
  const heightInMeters = height / 100;
  const bmi = (weight / (heightInMeters * heightInMeters)).toFixed(2);
  return bmi;
};

// Updated validateVitals function - only temperature required
const validateVitals = () => {
  const errors = {
    tem: false,
    pulse: false,
    res: false,
    pre: false,
    spo2: false,
    we: false
  };

  // Temperature is REQUIRED
  if (!vitalData.tem || vitalData.tem <= 0) {
    errors.tem = true;
  } else if (vitalData.tem < 30 || vitalData.tem > 45) {
    errors.tem = true; // Out of realistic range
  }

  // Pulse is OPTIONAL but if provided, must be in range
  if (vitalData.pulse && vitalData.pulse.toString().trim() !== '') {
    const pulseValue = Number(vitalData.pulse);
    if (pulseValue < 40 || pulseValue > 200) {
      errors.pulse = true;
    }
  }

  // Respiratory Rate is OPTIONAL but if provided, must be in range
  if (vitalData.res && vitalData.res.toString().trim() !== '') {
    const resValue = Number(vitalData.res);
    if (resValue < 8 || resValue > 40) {
      errors.res = true;
    }
  }

  // Blood Pressure is OPTIONAL but if provided, must be valid format
  if (vitalData.pre && vitalData.pre.trim() !== '') {
    const bpPattern = /^\d{2,3}\/\d{2,3}$/;
    if (!bpPattern.test(vitalData.pre)) {
      errors.pre = true;
    } else {
      const [systolic, diastolic] = vitalData.pre.split('/').map(Number);
      if (systolic < 70 || systolic > 250 || diastolic < 40 || diastolic > 150) {
        errors.pre = true;
      }
    }
  }

  // SpO2 is OPTIONAL but if provided, must be in range
  if (vitalData.spo2 && vitalData.spo2.toString().trim() !== '') {
    const spo2Value = Number(vitalData.spo2);
    if (spo2Value < 70 || spo2Value > 100) {
      errors.spo2 = true;
    }
  }

  // Weight is OPTIONAL but if provided, must be positive
  if (vitalData.we && vitalData.we.toString().trim() !== '') {
    const weightValue = Number(vitalData.we);
    if (weightValue <= 0 || weightValue > 500) {
      errors.we = true;
    }
  }

  setVitalErrors(errors);
  return !Object.values(errors).some(error => error);
};

// Updated handleSaveVitals with better error message
const handleSaveVitals = async () => {
  if (!validateVitals()) {
    ErrorMessage("Validation Error", "Temperature is required. All other values must be within valid ranges if provided.");
    return;
  }

  const confirmResult = await Swal.fire({
    title: selectedVital ? 'Update Vitals?' : 'Save Vitals?',
    text: selectedVital 
      ? "Do you want to update this vital signs record?" 
      : "Do you want to save these vital signs?",
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: selectedVital ? 'Yes, Update' : 'Yes, Save',
    cancelButtonText: 'Cancel'
  });

  if (!confirmResult.isConfirmed) return;

  setLoading(true);
  try {
    const calculatedBMI = calculateBMI(vitalData.we, vitalData.high);

    const response = await axios.post(saveVitalsdb, {
      patientId: selectedPatient.id,
      trans_code: selectedVital?.trans_code || null,
      tem: vitalData.tem,
      pulse: vitalData.pulse || null,
      res: vitalData.res || null,
      pre: vitalData.pre || null,
      spo2: vitalData.spo2 || null,
      we: vitalData.we || null,
      high: vitalData.high || null,
      bmi: calculatedBMI || null,
      user: currentUser,
      name: selectedPatient.fullName,
      age: selectedPatient.age,
      gender: selectedPatient.gender,
      status: selectedPatient.insurance,
      dat_vist: currentDate,
      time: moment().format('HH:mm:ss')
    });

    if (response.data.success) {
      successMessage("Success", response.data.message);
      await loadVitalsHistory();
      handleClearVitals();
      setComplianceRefreshKey(k => k + 1);
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error("Error saving vitals:", error);
    ErrorMessage("Error", error.response?.data?.message || "Failed to save vitals");
  } finally {
    setLoading(false);
  }
};

const handleDeleteVitals = async (vital) => {
  const confirmDelete = await Swal.fire({
    title: "Delete Vitals Record?",
    text: `Are you sure you want to delete this vital signs record from ${vital.dat_vist}?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6'
  });

  if (!confirmDelete.isConfirmed) return;

  setLoading(true);
  try {
    const response = await axios.post(deleteVitalsdb, {
      trans_code: vital.trans_code,
      user: currentUser
    });

    if (response.data.success) {
      Swal.fire("Deleted", response.data.message, "success");
      await loadVitalsHistory();
      if (selectedVital?.trans_code === vital.trans_code) {
        handleClearVitals();
      }
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error("Error deleting vitals:", error);
    ErrorMessage("Error", error.response?.data?.message || "Failed to delete vitals");
  } finally {
    setLoading(false);
  }
};


// FBS / RBS

// Blood Sugar States
const [fbsHistory, setFbsHistory] = useState([]);
const [rbsHistory, setRbsHistory] = useState([]);
const [selectedFbs, setSelectedFbs] = useState(null);
const [selectedRbs, setSelectedRbs] = useState(null);
const [fbsData, setFbsData] = useState({
  fbs: '',
  remark: ''
});
const [rbsData, setRbsData] = useState({
  rbs: '',
  insulin: '',
  remark: ''
});
const [fbsError, setFbsError] = useState(false);
const [rbsError, setRbsError] = useState(false);
const [bloodSugarTab, setBloodSugarTab] = useState(0); // 0 = FBS, 1 = RBS


// ==================== FBS Functions ====================

const loadFBSHistory = async () => {
  if (!selectedPatient) return;
  
  setLoading(true);
  try {
    const response = await axios.get(loadFBSHistorydb, {
      params: {
        patientId: selectedPatient.id,
        visitDate: selectedPatient.visitDate
      }
    });

    if (response.data.success) {
      const fbs = response.data.fbs || [];
      setFbsHistory(fbs);
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error("Error loading FBS history:", error);
    ErrorMessage("Error", "Failed to load FBS history");
  } finally {
    setLoading(false);
  }
};

const handleSelectFbs = (fbs) => {
  setSelectedFbs(fbs);
  setFbsData({
    fbs: fbs.FBS || '',
    remark: fbs.remark || ''
  });
};

const handleClearFbs = () => {
  setSelectedFbs(null);
  setFbsData({
    fbs: '',
    remark: ''
  });
  setFbsError(false);
};

const validateFbs = () => {
  if (!fbsData.fbs || fbsData.fbs <= 0) {
    setFbsError(true);
    return false;
  }
  
  const fbsValue = Number(fbsData.fbs);
  if (fbsValue < 2.2 || fbsValue > 33.3) {
    setFbsError(true);
    ErrorMessage("Validation Error", "FBS must be between 2.2-33.3 mmol/L");
    return false;
  }
  
  setFbsError(false);
  return true;
};

const handleSaveFbs = async () => {
  if (!validateFbs()) {
    ErrorMessage("Validation Error", "Please enter a valid FBS value (40-600 mg/dL)");
    return;
  }

  const confirmResult = await Swal.fire({
    title: selectedFbs ? 'Update FBS Record?' : 'Save FBS Record?',
    text: selectedFbs 
      ? "Do you want to update this FBS record?" 
      : "Do you want to save this FBS record?",
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: selectedFbs ? 'Yes, Update' : 'Yes, Save',
    cancelButtonText: 'Cancel'
  });

  if (!confirmResult.isConfirmed) return;

  setLoading(true);
  try {
    const response = await axios.post(saveFBSdb, {
      patientId: selectedPatient.id,
      trans_code: selectedFbs?.trans_code || null,
      fbs: fbsData.fbs,
      remark: fbsData.remark,
      dat: currentDate,
      time: moment().format('HH:mm:ss')
    });

    if (response.data.success) {
      successMessage("Success", response.data.message);
      await loadFBSHistory();
      handleClearFbs();
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error("Error saving FBS:", error);
    ErrorMessage("Error", error.response?.data?.message || "Failed to save FBS");
  } finally {
    setLoading(false);
  }
};

const handleDeleteFbs = async (fbs) => {
  const confirmDelete = await Swal.fire({
    title: "Delete FBS Record?",
    text: `Are you sure you want to delete this FBS record from ${fbs.dat}?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6'
  });

  if (!confirmDelete.isConfirmed) return;

  setLoading(true);
  try {
    const response = await axios.post(deleteFBSdb, {
      trans_code: fbs.trans_code
    });

    if (response.data.success) {
      Swal.fire("Deleted", response.data.message, "success");
      await loadFBSHistory();
      if (selectedFbs?.trans_code === fbs.trans_code) {
        handleClearFbs();
      }
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error("Error deleting FBS:", error);
    ErrorMessage("Error", error.response?.data?.message || "Failed to delete FBS");
  } finally {
    setLoading(false);
  }
};

// ==================== RBS Functions ====================

const loadRBSHistory = async () => {
  if (!selectedPatient) return;
  
  setLoading(true);
  try {
    const response = await axios.get(loadRBSHistorydb, {
      params: {
        patientId: selectedPatient.id,
        visitDate: selectedPatient.visitDate
      }
    });

    if (response.data.success) {
      const rbs = response.data.rbs || [];
      setRbsHistory(rbs);
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error("Error loading RBS history:", error);
    ErrorMessage("Error", "Failed to load RBS history");
  } finally {
    setLoading(false);
  }
};

const handleSelectRbs = (rbs) => {
  setSelectedRbs(rbs);
  setRbsData({
    rbs: rbs.RBS || '',
    insulin: rbs.insulin || '',
    remark: rbs.remark || ''
  });
};

const handleClearRbs = () => {
  setSelectedRbs(null);
  setRbsData({
    rbs: '',
    insulin: '',
    remark: ''
  });
  setRbsError(false);
};


const validateRbs = () => {
  if (!rbsData.rbs || rbsData.rbs <= 0) {
    setRbsError(true);
    return false;
  }
  
  const rbsValue = Number(rbsData.rbs);
  if (rbsValue < 2.2 || rbsValue > 33.3) {
    setRbsError(true);
    ErrorMessage("Validation Error", "RBS must be between 2.2-33.3 mmol/L");
    return false;
  }
  
  setRbsError(false);
  return true;
};

const handleSaveRbs = async () => {
  if (!validateRbs()) {
    ErrorMessage("Validation Error", "Please enter a valid RBS value (40-600 mg/dL)");
    return;
  }

  const confirmResult = await Swal.fire({
    title: selectedRbs ? 'Update RBS Record?' : 'Save RBS Record?',
    text: selectedRbs 
      ? "Do you want to update this RBS record?" 
      : "Do you want to save this RBS record?",
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: selectedRbs ? 'Yes, Update' : 'Yes, Save',
    cancelButtonText: 'Cancel'
  });

  if (!confirmResult.isConfirmed) return;

  setLoading(true);
  try {
    const response = await axios.post(saveRBSdb, {
      patientId: selectedPatient.id,
      trans_code: selectedRbs?.trans_code || null,
      rbs: rbsData.rbs,
      insulin: rbsData.insulin,
      remark: rbsData.remark,
      dat: currentDate,
      time: moment().format('HH:mm:ss')
    });

    if (response.data.success) {
      successMessage("Success", response.data.message);
      await loadRBSHistory();
      handleClearRbs();
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error("Error saving RBS:", error);
    ErrorMessage("Error", error.response?.data?.message || "Failed to save RBS");
  } finally {
    setLoading(false);
  }
};

const handleDeleteRbs = async (rbs) => {
  const confirmDelete = await Swal.fire({
    title: "Delete RBS Record?",
    text: `Are you sure you want to delete this RBS record from ${rbs.dat}?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6'
  });

  if (!confirmDelete.isConfirmed) return;

  setLoading(true);
  try {
    const response = await axios.post(deleteRBSdb, {
      trans_code: rbs.trans_code
    });

    if (response.data.success) {
      Swal.fire("Deleted", response.data.message, "success");
      await loadRBSHistory();
      if (selectedRbs?.trans_code === rbs.trans_code) {
        handleClearRbs();
      }
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error("Error deleting RBS:", error);
    ErrorMessage("Error", error.response?.data?.message || "Failed to delete RBS");
  } finally {
    setLoading(false);
  }
};


//medication sheet

const [firstDoseDate, setFirstDoseDate] = useState(moment().format('YYYY-MM-DD'));
const [firstDoseTime, setFirstDoseTime] = useState(moment().format('HH:mm'));

const [patientMedications, setPatientMedications] = useState([]);
const [selectedMedForChart, setSelectedMedForChart] = useState(null);
const [chartStartDate, setChartStartDate] = useState(moment().format('YYYY-MM-DD'));
const [chartEndDate, setChartEndDate] = useState(moment().add(3, 'days').format('YYYY-MM-DD'));
const [chartedMedications, setChartedMedications] = useState([]);
const [medSheetDialogOpen, setMedSheetDialogOpen] = useState(false);
const [selectedChartMed, setSelectedChartMed] = useState(null);
const [servedBy, setServedBy] = useState('');




// Resolve a frequency string to doses-per-day. See Wards/InPatient.js for
// the canonical version of this logic — kept in sync.
const resolveDosesPerDay = (rawFreq) => {
  const norm = String(rawFreq || '').toLowerCase().trim();
  const canonical = frequencyMap[norm] || rawFreq;
  const n = frequencyMultiplier[canonical];
  if (typeof n === 'number') return n;
  return 1;
};

// Build a deterministic dose schedule anchored on the nurse's chosen first
// dose date/time (interval = 24/dosesPerDay hours). Replaces the old broken
// "fixed clock times from frequencyTimeMap" approach.
const generateMedicationChart = (medication, firstDoseDate, firstDoseTime) => {
  const charts = [];
  const freq = String(medication.freq || '').toLowerCase().trim();
  const dosesPerDay = resolveDosesPerDay(medication.freq);

  const medDays  = Math.max(1, parseInt(medication.day_server, 10) || 1);
  const qty      = parseInt(medication.qua, 10);
  const quantity = Number.isFinite(qty) && qty > 0 ? qty : Number.POSITIVE_INFINITY;

  const firstDose = moment(`${firstDoseDate} ${firstDoseTime}`, 'YYYY-MM-DD HH:mm');

  const isPrn  = dosesPerDay === 0
    || /\bprn\b|as needed|if necessary|sos/i.test(freq);
  const isStat = /\bstat\b|^immediately$|^now$/i.test(freq);

  // Explicit hour-offsets take priority. Regimens like artesunate's
  // "At 0, 12 and 24 hours" would otherwise collapse to 8-hourly because
  // 24 / 3 doses = 8, which is not what the doctor prescribed.
  const explicitOffsets = (isPrn || isStat) ? null : resolveDoseOffsets(medication.freq);

  let totalDoses;
  let intervalHours;

  if (isPrn || isStat) {
    totalDoses    = 1;
    intervalHours = 0;
  } else if (explicitOffsets) {
    totalDoses    = explicitOffsets.length;
    intervalHours = 0;
  } else {
    intervalHours = 24 / dosesPerDay;
    totalDoses    = Math.max(1, Math.floor(medDays * dosesPerDay));
  }

  totalDoses = Math.min(totalDoses, quantity);

  for (let i = 0; i < totalDoses; i++) {
    let scheduleTime;
    if (isPrn || isStat) scheduleTime = moment(firstDose);
    else if (explicitOffsets) scheduleTime = moment(firstDose).add(explicitOffsets[i], 'hours');
    else scheduleTime = moment(firstDose).add(i * intervalHours, 'hours');

    const medDescription = `${medication.name} ${medication.dose || ''} ${medication.Dose_Unit || ''} ${medication.freq} ${medication.rou || ''}`.replace(/\s+/g, ' ').trim();

    charts.push({
      id:    selectedPatient.id,
      dat:   scheduleTime.format('MM/DD'),
      time:  scheduleTime.format('hh:mm:ss A'),
      due_at: scheduleTime.format('YYYY-MM-DD HH:mm:ss'),
      med:   medDescription,
      name:  selectedPatient.fullName,
      age:   selectedPatient.age,
      d_dat: scheduleTime.format('YYYY-MM-DD'),
      s_by:  'i',
      user:  currentUser,
      trans_code: medication.trans_code,
      medication_trans_code: medication.trans_code,
    });
  }

  return charts;
};

// Helper function to convert time string to 24-hour format
const convertTo24Hour = (timeStr) => {
  const time = moment(timeStr, 'hh:mm:ss A');
  return time.format('HH:mm');
};


// Load Patient Medications for Charting
const loadPatientMedicationsForChart = async () => {
  if (!selectedPatient) return;
  
  setLoading(true);
  try {
    const response = await axios.get(loadPatientMedicationsForChartdb, {
      params: {
        patientId: selectedPatient.id,
        visitDate: selectedPatient.visitDate
      }
    });

    if (response.data.success) {
      setPatientMedications(response.data.medications || []);
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error("Error loading patient medications:", error);
    ErrorMessage("Error", "Failed to load patient medications");
  } finally {
    setLoading(false);
  }
};


// Save Medication Chart - UPDATED TO ALLOW MULTIPLE CHARTS
const handleChartMedication = async () => {
  if (!selectedMedForChart) {
    ErrorMessage("Error", "Please select a medication to chart");
    return;
  }

  if (!firstDoseDate || !firstDoseTime) {
    ErrorMessage("Error", "Please provide first dose date and time");
    return;
  }

  // Validate that the medication has quantity
  const quantity = parseInt(selectedMedForChart.qua) || 0;
  if (quantity <= 0) {
    ErrorMessage("Error", "Medication has no quantity available. Please ensure medication is dispensed first.");
    return;
  }

  // Check if this medication is already charted
  const isAlreadyCharted = chartedMedications.some(chart => 
    chart.med.toLowerCase().includes(selectedMedForChart.name.toLowerCase())
  );

  if (isAlreadyCharted) {
    const confirmResult = await Swal.fire({
      title: 'Medication Already Charted',
      html: `
        <div style="text-align: left;">
          <p><strong>${selectedMedForChart.name}</strong> has already been charted for this patient.</p>
          <br/>
          <p><strong>Do you want to chart it again?</strong></p>
          <p style="color: #666; font-size: 0.9em;">This might be needed for:</p>
          <ul style="color: #666; font-size: 0.9em;">
            <li>Different dosing schedule</li>
            <li>New prescription after completing previous course</li>
            <li>PRN (as needed) medications</li>
            <li>Different route of administration</li>
          </ul>
        </div>
      `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Chart Again',
      cancelButtonText: 'Cancel'
    });

    if (!confirmResult.isConfirmed) return;
  }

  const confirmChart = await Swal.fire({
    title: 'Chart Medication?',
    html: `
      <div style="text-align: left;">
        <p><strong>Medication:</strong> ${selectedMedForChart.name}</p>
        <p><strong>First Dose:</strong> ${moment(`${firstDoseDate} ${firstDoseTime}`).format('DD/MM/YYYY hh:mm A')}</p>
        <p><strong>Frequency:</strong> ${selectedMedForChart.freq}</p>
        <p><strong>Duration:</strong> ${selectedMedForChart.day_server} days</p>
        <p><strong>Total Quantity:</strong> ${quantity}</p>
      </div>
    `,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, Chart It',
    cancelButtonText: 'Cancel'
  });

  if (!confirmChart.isConfirmed) return;

  setLoading(true);
  try {
    const charts = generateMedicationChart(selectedMedForChart, firstDoseDate, firstDoseTime);
    
    if (charts.length === 0) {
      ErrorMessage("Error", "No chart entries generated. Please check medication details.");
      setLoading(false);
      return;
    }
    
    const response = await axios.post(saveChartedMedicationdb, {
      charts: charts,
      medicationTransCode: selectedMedForChart.trans_code
    });

    if (response.data.success) {
      let message = `Medication charted successfully. ${charts.length} entries created.`;
      
      if (response.data.hasExistingCharts) {
        message += ` (Note: This medication has other active charts)`;
      }
      
      successMessage("Success", message);
      await loadChartedMedications();
      await loadPatientMedicationsForChart(); // Reload to update charted status
      setSelectedMedForChart(null);
      setFirstDoseDate(moment().format('YYYY-MM-DD'));
      setFirstDoseTime(moment().format('HH:mm'));
      setMedSheetDialogOpen(false);
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error("Error charting medication:", error);
    ErrorMessage("Error", error.response?.data?.message || "Failed to chart medication");
  } finally {
    setLoading(false);
  }
};

// Load Charted Medications
const loadChartedMedications = async () => {
  if (!selectedPatient) return;
  
  setLoading(true);
  try {
    const response = await axios.get(loadChartedMedicationsdb, {
      params: {
        patientId: selectedPatient.id,
        startDate: selectedPatient.visitDate
      }
    });

    if (response.data.success) {
      setChartedMedications(response.data.charts || []);
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error("Error loading charted medications:", error);
    ErrorMessage("Error", "Failed to load charted medications");
  } finally {
    setLoading(false);
  }
};

// Mark as Served
const handleMarkAsServed = async (chart) => {
  const confirmResult = await Swal.fire({
    title: 'Mark as Served',
    html: `
      <div style="text-align: left; padding: 10px;">
        <p style="margin-bottom: 10px;"><strong>Medication:</strong></p>
        <p style="color: #666; margin-bottom: 15px;">${chart.med}</p>
        
        <p style="margin-bottom: 10px;"><strong>Scheduled Time:</strong></p>
        <p style="color: #666; margin-bottom: 15px;">${chart.dat} ${chart.time}</p>
        
        <p style="margin-bottom: 10px;"><strong>Served By:</strong></p>
        <div style="background-color: #e3f2fd; padding: 12px; border-radius: 5px; border-left: 4px solid #2196f3;">
          <p style="margin: 0; font-weight: 600; color: #1976d2; font-size: 1.1em;">${currentUser}</p>
        </div>
        
        <p style="margin-top: 15px; font-size: 0.9em; color: #666;">
          <em>Note: You are confirming that you have administered this medication</em>
        </p>
      </div>
    `,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#4caf50',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, Mark as Served',
    cancelButtonText: 'Cancel',
    customClass: {
      popup: 'swal-wide'
    }
  });

  if (!confirmResult.isConfirmed) return;

  setLoading(true);
  try {
    const response = await axios.post(markMedicationAsServeddb, {
      code: chart.code,
      servedBy: currentUser
    });

    if (response.data.success) {
      successMessage("Success", "Medication marked as served");
      await loadChartedMedications();
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error("Error marking as served:", error);
    ErrorMessage("Error", "Failed to mark medication as served");
  } finally {
    setLoading(false);
  }
};

// Delete Charted Medication
const handleDeleteChartedMed = async (chart) => {
  const confirmDelete = await Swal.fire({
    title: "Delete Chart Entry?",
    text: `Are you sure you want to delete this medication chart entry?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6'
  });

  if (!confirmDelete.isConfirmed) return;

  setLoading(true);
  try {
    const response = await axios.post(deleteChartedMedicationdb, {
      code: chart.code
    });

    if (response.data.success) {
      Swal.fire("Deleted", response.data.message, "success");
      await loadChartedMedications();
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error("Error deleting chart:", error);
    ErrorMessage("Error", "Failed to delete chart entry");
  } finally {
    setLoading(false);
  }
};

const [VitalsHistoryOpennow ,setVitalsHistoryOpennow ]=useState(false)
const [labHistoryOpennow  ,setlabHistoryOpennow ]=useState(false)
const [ScanHistoryOpennow  ,setScanHistoryOpennow ]=useState(false)
const [openmedHisnow  ,setopenmedHisnow ]=useState(false)
const [labOpennow , setLabOpennow] = useState(false);


const historyButtons = [
    {
      label: 'Vitals',
      icon: <MonitorHeartIcon />,
      onClick: () => setVitalsHistoryOpennow (true),
      color: '#e53935',
      bgColor: 'rgba(229, 57, 53, 0.08)'
    },
    {
      label: 'Labs',
      icon: <ScienceIcon />,
      onClick: () => setlabHistoryOpennow(true),
      color: '#1e88e5',
      bgColor: 'rgba(30, 136, 229, 0.08)'
    },
    {
      label: 'Scan',
      icon: <LocalHospitalIcon />,
      onClick: () => setScanHistoryOpennow(true),
      color: '#43a047',
      bgColor: 'rgba(67, 160, 71, 0.08)'
    },
    {
      label: 'Medications',
      icon: <MedicalServicesIcon />,
      onClick: () => setopenmedHisnow(true),
      color: '#fb8c00',
      bgColor: 'rgba(251, 140, 0, 0.08)'
    } ,

    {
      label: 'Medications Sheet',
      icon: <TopicIcon />,
      onClick: () => setMedSheetOpen(true),
      color: '#fb8c00',
      bgColor: 'rgba(251, 140, 0, 0.08)'
    },

     {
      label: 'Nurses Note',
      icon: <EditNoteIcon />,
     // onClick: () => setopenmedHis(true),
      color: '#fb8c00',
      bgColor: 'rgba(251, 140, 0, 0.08)'
    }
];


// Transer

// Load all wards
const loadWards = async () => {
  setLoading(true);
  try {
    const response = await axios.get(loadWardsdb);
    
    if (response.data.success) {
      setWards(response.data.wards);
    }
  } catch (error) {
    console.error('Error loading wards:', error);
    ErrorMessage('Error', 'Failed to load wards');
  } finally {
    setLoading(false);
  }
};

// Load available beds in selected ward
const loadAvailableBeds = async (wardId) => {
  setLoading(true);
  try {
    const response = await axios.get(loadAvailableBedsdb, {
      params: { wardId }
    });
    
    if (response.data.success) {
      setAvailableBeds(response.data.beds);
    }
  } catch (error) {
    console.error('Error loading beds:', error);
    ErrorMessage('Error', 'Failed to load available beds');
  } finally {
    setLoading(false);
  }
};

// Load patient's current bed assignment
const loadPatientCurrentBed = async () => {
  if (!selectedPatient) return;
  
  setLoading(true);
  try {
    const response = await axios.get(loadPatientCurrentBeddb, {
      params: { 
        patientId: selectedPatient.id,
        patientName: selectedPatient.fullName  // ← ADDED THIS
      }
    });
    
    if (response.data.success) {
      setCurrentBedInfo(response.data.currentBed);
    } else {
      setCurrentBedInfo(null);
      // Don't show error if just no bed assigned
    }
  } catch (error) {
    console.error('Error loading current bed:', error);
    ErrorMessage('Error', 'Failed to load current bed information');
  } finally {
    setLoading(false);
  }
};

// Handle ward selection
const handleWardSelect = (wardId) => {
  setSelectedWard(wardId);
  setSelectedBed(null);
  setAvailableBeds([]);
  loadAvailableBeds(wardId);
};

// Handle transfer
const handleTransferPatient = async () => {
  if (!selectedWard || !selectedBed) {
    ErrorMessage('Error', 'Please select both ward and bed');
    return;
  }

  if (!transferReason.trim()) {
    ErrorMessage('Error', 'Please provide a transfer reason');
    return;
  }

  // ✅ OLD location (from currentBedInfo)
  const oldWardId = currentBedInfo?.ward_id;
  const oldBedId  = currentBedInfo?.bed_id;

  if (!oldWardId || !oldBedId) {
    ErrorMessage('Error', 'Current bed information not found');
    return;
  }

  const confirmResult = await Swal.fire({
    title: 'Confirm Ward Transfer',
    html: `
      <div style="text-align:left">
        <p><b>Patient:</b> ${selectedPatient.fullName}</p>
        <p><b>From:</b> ${currentBedInfo.ward_name} - ${currentBedInfo.bed_number}</p>
        <p><b>To:</b> ${wards.find(w => w.id === selectedWard)?.name} - 
                      ${availableBeds.find(b => b.bed_id === selectedBed)?.bed_number}</p>
        <p><b>Reason:</b> ${transferReason}</p>
      </div>
    `,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Yes, Transfer',
    cancelButtonText: 'Cancel'
  });

  if (!confirmResult.isConfirmed) return;

  setLoading(true);

  try {
    const response = await axios.post(transferPatientWardBeddb, {
      patientId: selectedPatient.id,
      patientName: selectedPatient.fullName,

      // ✅ SEND OLD LOCATION
      oldWardId,
      oldBedId,

      // ✅ SEND NEW LOCATION
      newWardId: selectedWard,
      newBedId: selectedBed,

      transferReason,
      transferredBy: currentUser
    });

    if (response.data.success) {
      successMessage('Success', response.data.message);

      setTransferDialogOpen(false);
      setSelectedWard(null);
      setSelectedBed(null);
      setTransferReason('');
      setAvailableBeds([]);

      loadPatientCurrentBed();
      loadPatients();
    } else {
      ErrorMessage('Error', response.data.message);
    }
  } catch (error) {
    ErrorMessage(
      'Error',
      error.response?.data?.message || 'Failed to transfer patient'
    );
  } finally {
    setLoading(false);
  }
};


// Open transfer dialog
const handleOpenTransferDialog = () => {
  loadWards();
  loadPatientCurrentBed();
  setTransferDialogOpen(true);
};

  return (
    <Box sx={{
      bgcolor: "#f5f5f5", minHeight: "100vh", p: 1.5,
      // Density baseline — applies inside the InPatient view only.
      // Dialogs portal out of this tree, so they keep their own sizing.
      '& .MuiTypography-h4': { fontSize: '1.2rem' },
      '& .MuiTypography-h5': { fontSize: '1.05rem' },
      '& .MuiTypography-h6': { fontSize: '0.95rem', fontWeight: 700 },
      '& .MuiCardContent-root': { padding: '12px', '&:last-child': { paddingBottom: '12px' } },
      // Compact medium buttons — px values, NOT theme spacing units.
      '& .MuiButton-sizeMedium': {
        paddingTop: '4px', paddingBottom: '4px',
        paddingLeft: '10px', paddingRight: '10px',
        fontSize: '0.78rem', minHeight: '30px',
      },
      '& .MuiButton-sizeSmall': {
        paddingTop: '2px', paddingBottom: '2px',
        paddingLeft: '8px', paddingRight: '8px',
        fontSize: '0.75rem', minHeight: '26px',
      },
      '& .MuiTab-root': { minHeight: 38 },
      '& .MuiTabs-root': { minHeight: 38 },
    }}>
      {loading && (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          bgcolor: "rgba(0,0,0,0.4)",
          backdropFilter: "blur(2px)",
          zIndex: 2000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <CircularProgress size={70} thickness={5} />
      </Box>
)}

      <Container maxWidth="xl">
        {/* Persistent bell — outside the conditional so it doesn't remount
            (and refetch) every time the user picks or leaves a patient. */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
          <ComplianceFollowupBell
            wardIds={assignedWardIds}
            currentUser={currentUser}
            onAddVitals={(row) => {
              const match = allPatients.find(p => p.id === row.patientId);
              if (match) { pendingTabRef.current = 'vitals'; setSelectedPatient(match); }
            }}
            onAddNote={(row) => {
              const match = allPatients.find(p => p.id === row.patientId);
              if (match) { pendingTabRef.current = 'notes'; setSelectedPatient(match); }
            }}
          />
        </Box>

        {/* Compliance FAB — self-renders a floating button + dialog, so it
            stays mounted regardless of whether a patient is selected. */}
        <ComplianceAlerts
          scope="emergency"
          wardIds={assignedWardIds}
          refreshKey={complianceRefreshKey}
          onSelectPatient={(row, tab) => {
            const match = allPatients.find(p => p.id === row.id);
            if (match) {
              pendingTabRef.current = tab === 'vitals' ? 'vitals' : 'notes';
              setSelectedPatient(match);
            }
          }}
        />

        {/* ── PATIENT WORKLIST TABLE — shown when no patient is selected ── */}
        {!selectedPatient && (
          <PatientTable
            patients={allPatients}
            onSelectPatient={setSelectedPatient}
            onTransferToWard={handleTransferToWard}
            currentUser={currentUser}
          />
        )}

        {/* ── PATIENT WORKSPACE — shown when a patient is selected ── */}
        {selectedPatient && (
        <>
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2.5,
          flexWrap: 'wrap',
          gap: 2,
        }}>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Tooltip title="Back to patient list" arrow>
              <IconButton
                onClick={() => { setSelectedPatient(null); setSearchTerm(''); }}
                size="small"
                sx={{
                  bgcolor: 'rgba(26,155,127,0.10)',
                  color: '#1A9B7F',
                  '&:hover': { bgcolor: 'rgba(26,155,127,0.18)' },
                }}
              >
                <ArrowBack sx={{ fontSize: 18 }} />
              </IconButton>
            </Tooltip>
            <Box>
              <Typography sx={{
                fontSize: '0.7rem', fontWeight: 700,
                color: '#1A9B7F', letterSpacing: '1.2px', textTransform: 'uppercase',
              }}>
                Patient Workspace
              </Typography>
              <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#0f172a', lineHeight: 1.25 }}>
                {selectedPatient.fullName}
                <Box component="span" sx={{ fontWeight: 500, color: '#64748b', fontSize: '0.85rem', ml: 1 }}>
                  · ID {selectedPatient.id}
                </Box>
              </Typography>
            </Box>
          </Stack>

          {/* Prev / position / Next — cycle through assigned patients */}
          {currentPatientIndex >= 0 && allPatients.length > 1 && (
            <Stack
              direction="row"
              alignItems="center"
              spacing={0.5}
              sx={{
                bgcolor: '#fff',
                border: '1px solid #e5e9ef',
                borderRadius: 1.75,
                px: 0.5,
                py: 0.25,
              }}
            >
              <Tooltip title={hasPrevPatient ? 'Previous patient (←)' : 'No previous patient'} arrow>
                <span>
                  <IconButton
                    size="small"
                    onClick={goToPrevPatient}
                    disabled={!hasPrevPatient}
                    sx={{
                      color: '#1A9B7F',
                      '&.Mui-disabled': { color: '#cbd5e1' },
                      '&:hover': { bgcolor: 'rgba(26,155,127,0.10)' },
                    }}
                  >
                    <ArrowBackIosNew sx={{ fontSize: 14 }} />
                  </IconButton>
                </span>
              </Tooltip>

              <Box sx={{
                px: 1.25, minWidth: 78, textAlign: 'center',
                borderLeft: '1px solid #f1f5f9',
                borderRight: '1px solid #f1f5f9',
              }}>
                <Typography sx={{ fontSize: '0.85rem', fontWeight: 700, color: '#0f172a', lineHeight: 1.1 }}>
                  {currentPatientIndex + 1}
                  <Box component="span" sx={{ color: '#94a3b8', fontWeight: 500, mx: 0.4 }}>
                    of
                  </Box>
                  {allPatients.length}
                </Typography>
                <Typography sx={{ fontSize: '0.62rem', color: '#94a3b8', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
                  Patient
                </Typography>
              </Box>

              <Tooltip title={hasNextPatient ? 'Next patient (→)' : 'No next patient'} arrow>
                <span>
                  <IconButton
                    size="small"
                    onClick={goToNextPatient}
                    disabled={!hasNextPatient}
                    sx={{
                      color: '#1A9B7F',
                      '&.Mui-disabled': { color: '#cbd5e1' },
                      '&:hover': { bgcolor: 'rgba(26,155,127,0.10)' },
                    }}
                  >
                    <ArrowForwardIos sx={{ fontSize: 14 }} />
                  </IconButton>
                </span>
              </Tooltip>
            </Stack>
          )}
        </Box>

    <Paper sx={{ p: 2, mb: 3 }}>
      <Autocomplete
        fullWidth
        freeSolo
        open={searchOpen}
        onOpen={() => {
          if (searchResults.length > 0 && searchTerm.length > 0)
            setSearchOpen(true);
        }}
        onClose={() => setSearchOpen(false)}
        inputValue={searchTerm}
        onInputChange={(event, newInputValue) => {
          setSearchTerm(newInputValue);
          if (newInputValue.length < 1) {
            setSearchOpen(false);
            setSearchResults([]);
          }
        }}
        options={searchResults}
        loading={searchLoading}
        getOptionLabel={(option) => `${option.fullName} (${option.id})`}
        renderOption={(props, option) => (
          <Box
            component="li"
            {...props}
            onClick={() => {
              setSelectedPatient(option);
              setSearchOpen(false);
            }}
            sx={{
              borderBottom: "1px solid",
              borderColor: "divider",
              "&:last-child": { borderBottom: "none" },
              p: 2,
              cursor: "pointer",
              "&:hover": { bgcolor: "action.hover" },
            }}
          >
            <Box display="flex" alignItems="center" gap={2} width="100%">
              <Avatar sx={{ bgcolor: "primary.main" }}>
                <Person />
              </Avatar>
              <Box flex={1}>
                <Typography variant="subtitle1" fontWeight="bold">
                  {option.fullName}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  ID: {option.id}
                </Typography>
                <Stack direction="row" spacing={1} sx={{ mt: 0.5 }}>
                  <Chip
                    size="small"
                    label={option.gender}
                    color={option.gender === "MALE" ? "info" : "error"}
                  />
                  <Chip size="small" label={option.insurance} />
                  <Chip
                    size="small"
                    label={option.state}
                    color={
                      option.state === "inPatient" ? "success" : "warning"
                    }
                  />
                </Stack>
              </Box>
              <Box textAlign="right">
                <Typography variant="body2" color="text.secondary">
                  {option.tel}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Age: {option.age}
                </Typography>
              </Box>
            </Box>
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Search patient by ID, Name"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <Search sx={{ color: "action.active", mr: 1 }} />
              ),
              endAdornment: (
                <>
                  {searchLoading ? (
                    <CircularProgress color="inherit" size={25} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Paper>

       
{/* Sentinel for the IntersectionObserver — drives auto collapse/expand */}
{selectedPatient && (
  <Box ref={bannerSentinelRef} sx={{ height: 1, mb: 0 }} />
)}

{/* Slim sticky strip — always shown when banner is collapsed (auto on scroll
    or manual). Click anywhere on it (or the chevron) to expand the full
    banner. Stays out of the way otherwise. */}
{selectedPatient && bannerCollapsed && (
  <Box
    onClick={() => { setBannerCollapsed(false); setBannerManual(true); }}
    sx={{
      position: 'sticky', top: 0, zIndex: 50,
      mb: 1, mx: -1.5, px: 1.5,
      py: 0.75,
      bgcolor: '#fff',
      borderBottom: '1px solid #e5e9ef',
      boxShadow: '0 2px 6px rgba(15,23,42,0.04)',
      display: 'flex', alignItems: 'center', gap: 1.25,
      cursor: 'pointer',
      transition: 'background-color .15s ease',
      '&:hover': { bgcolor: '#f8fafc' },
    }}
  >
    <Avatar sx={{
      width: 28, height: 28, fontSize: 12, fontWeight: 700,
      bgcolor: '#dc2626', color: '#fff',
    }}>
      {(selectedPatient.fullName || '?').split(/\s+/).slice(0,2).map(s => s[0]).join('').toUpperCase()}
    </Avatar>
    <Typography sx={{ fontSize: '0.85rem', fontWeight: 700, color: '#0f172a', flex: 1, minWidth: 0 }} noWrap>
      {selectedPatient.fullName}
      <Box component="span" sx={{ color: '#64748b', fontWeight: 500, ml: 0.75 }}>· {selectedPatient.id}</Box>
    </Typography>
    <Tooltip title="Show patient details" arrow>
      <IconButton size="small" sx={{ color: '#dc2626' }}>
        <KeyboardArrowDown />
      </IconButton>
    </Tooltip>
  </Box>
)}

{selectedPatient && (
  <Collapse in={!bannerCollapsed} timeout={220}>
  <Card
    sx={{
      mb: 1.5,
      boxShadow: '0 2px 10px rgba(15,23,42,0.06)',
      borderRadius: 2,
      overflow: 'hidden',
      position: 'relative',
      opacity: selectedPatient.state === 'Discharge' ? 0.6 : 1,
      pointerEvents: selectedPatient.state === 'Discharge' ? 'none' : 'auto'
    }}
  >
    {/* Manual collapse toggle — top-right of the banner */}
    <Tooltip title="Hide patient details" arrow>
      <IconButton
        size="small"
        onClick={() => { setBannerCollapsed(true); setBannerManual(true); }}
        sx={{
          position: 'absolute', top: 6, right: 6, zIndex: 6,
          bgcolor: 'rgba(15,23,42,0.04)', color: '#475569',
          '&:hover': { bgcolor: 'rgba(15,23,42,0.10)' },
        }}
      >
        <KeyboardArrowUp />
      </IconButton>
    </Tooltip>
    {selectedPatient.state === 'Discharge' && (
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: 'rgba(0, 0, 0, 0.05)',
          zIndex: 10,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          pointerEvents: 'auto'
        }}
      >
        <LockIcon sx={{ fontSize: 120, color: 'error.main', opacity: 0.8 }} />
        <Typography variant="h4" fontWeight={700} color="error.main">
          PATIENT DISCHARGED
        </Typography>
        <Typography variant="h6" color="text.secondary">
          This patient was discharged and records are locked
        </Typography>
       
      </Box>
    )}

   

    <Box
      sx={{
        p: 1.5,
        borderBottom: '1px solid',
        borderColor: 'rgba(220,38,38,0.30)',
        bgcolor: '#f8fafc'
      }}
    >
      <Grid container spacing={1.5} alignItems="flex-start" columns={{ xs: 4, sm: 8, md: 12 }}>
        <Grid item xs={12} md={3} size={4}>
          <Box display="flex" alignItems="center" gap={1.25}>
            <Avatar
              sx={{
                bgcolor: 'white',
                color: 'primary.main',
                width: 44,
                height: 44,
                fontSize: 16,
                fontWeight: 700,
                boxShadow: '0 2px 8px rgba(0,0,0,0.10)'
              }}
            >
              {selectedPatient.fullName
                .split(" ")
                .map((n) => n[0])
                .join("")
                .slice(0, 2)}
            </Avatar>
            <Box>
              <Typography sx={{ fontSize: '0.95rem', fontWeight: 700, color: '#0f172a', lineHeight: 1.2 }}>
                {selectedPatient.fullName}
              </Typography>
              <Typography sx={{ fontSize: '0.75rem', color: '#64748b', mt: 0.25, mb: 0.5 }}>
                {selectedPatient.age} yrs · ID {selectedPatient.id}
              </Typography>
              <Stack direction="row" spacing={1}>
                <Chip
                  size="small"
                  label={selectedPatient.gender}
                  sx={{
                    bgcolor: selectedPatient.gender === "MALE" 
                      ? 'rgba(33, 150, 243, 0.9)' 
                      : 'rgba(244, 67, 54, 0.9)',
                    color: 'white',
                    fontWeight: 600
                  }}
                />
                <Chip
                  size="small"
                  label={selectedPatient.insurance}
                  sx={{ 
                    bgcolor: 'rgba(255, 152, 0, 0.9)', 
                    color: 'white',
                    fontWeight: 600,
                    
                  }}
                />
              </Stack>
              
               {/* Detention Badge  */}
                
                {selectedPatient.status === 'Detention' && (() => {
                  const detentionStart = moment(selectedPatient.currtime);
                  const now = moment();
                  const detentionEnd = detentionStart.clone().add(30, 'hours');
                  const totalDuration = 30 * 60; // 30 hours in minutes
                  const elapsed = now.diff(detentionStart, 'minutes');
                  const percentage = Math.min(100, (elapsed / totalDuration) * 100);

                  return (
                    <Box
                      sx={{
                        mt: 3,
                        bgcolor: 'warning.main',
                        color: 'white',
                        px: 3,
                        py: 1.5,
                        borderRadius: 2,
                        boxShadow: '0 4px 12px rgba(255, 152, 0, 0.4)',
                        zIndex: 5,
                        animation: 'pulse 2s ease-in-out infinite',
                        '@keyframes pulse': {
                          '0%, 100%': {
                            boxShadow: '0 4px 12px rgba(255, 152, 0, 0.4)',
                          },
                          '50%': {
                            boxShadow: '0 4px 20px rgba(255, 152, 0, 0.7)',
                          }
                        }
                      }}
                    >
                      {/* Header */}
                      <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                        <Box display="flex" alignItems="center" gap={1}>
                          <LockIcon sx={{ fontSize: 24 }} />
                          <Typography variant="h6" fontWeight={700} sx={{ letterSpacing: 1 }}>
                            🔒 DETENTION
                          </Typography>
                        </Box>
                        
                        {detentionTimeLeft && (
                          <Typography 
                            variant="body2" 
                            fontWeight={600}
                            sx={{ 
                              fontFamily: 'monospace',
                              bgcolor: 'rgba(0, 0, 0, 0.2)',
                              px: 2,
                              py: 0.5,
                              borderRadius: 1
                            }}
                          >
                            {detentionTimeLeft === 'EXPIRED' ? '⚠️ EXPIRED' : `⏱️ ${detentionTimeLeft}`}
                          </Typography>
                        )}
                      </Box>

                      {/* Progress Bar */}
                      <Box sx={{ width: '100%', bgcolor: 'rgba(0, 0, 0, 0.2)', borderRadius: 1, height: 8 }}>
                        <Box
                          sx={{
                            width: `${percentage}%`,
                            bgcolor: percentage > 90 ? 'error.main' : percentage > 70 ? 'warning.light' : '#4caf50',
                            height: '100%',
                            borderRadius: 1,
                            transition: 'all 0.5s ease'
                          }}
                        />
                      </Box>
                    </Box>
                  );
                })()}

              {/* Transfer-to-Ward action lives on the patient list table
                  (one button per row). See PatientTable's `onTransferToWard`
                  prop wired in this view. */}

              {/* Emergency Time Badge — count-up since admission */}
              {selectedPatient.status === 'Emergency' && (
                <Box
                  sx={{
                    mt: 3,
                    bgcolor: '#dc2626',
                    color: 'white',
                    px: 3,
                    py: 1.25,
                    borderRadius: 2,
                    boxShadow: '0 4px 12px rgba(220,38,38,0.35)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                    animation: 'erpulse 2.2s ease-in-out infinite',
                    '@keyframes erpulse': {
                      '0%, 100%': { boxShadow: '0 4px 12px rgba(220,38,38,0.35)' },
                      '50%':      { boxShadow: '0 4px 22px rgba(220,38,38,0.65)' },
                    },
                  }}
                >
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="h6" fontWeight={700} sx={{ letterSpacing: 1 }}>
                      🚨 EMERGENCY
                    </Typography>
                  </Box>
                  <Typography
                    variant="body2"
                    fontWeight={700}
                    sx={{
                      fontFamily: 'monospace',
                      fontSize: '1rem',
                      bgcolor: 'rgba(0,0,0,0.22)',
                      px: 2,
                      py: 0.5,
                      borderRadius: 1,
                    }}
                  >
                    ⏱️ {erTimeElapsed || '00:00:00'}
                  </Typography>
                </Box>
              )}

            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} md={3} size={3} >
          <Stack spacing={1.5}>
            <Box>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                Contact Information
              </Typography>
              <Typography variant="body1" fontWeight={500}>
                📞 {selectedPatient.tel}
              </Typography>
              <Typography variant="body1" fontWeight={500}>
                📍 {selectedPatient.location}
              </Typography>
            </Box>
            
            <Box>
              <Chip
                label={selectedPatient.status}
                sx={{ 
                  bgcolor: 'rgba(255, 193, 7, 0.9)',
                  color: 'white',
                  fontWeight: 600,
                  mb: 1
                }}
              />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Visit Date: {selectedPatient.visitDate}
              </Typography>
                <Button
                    variant="outlined"
                    color="warning"
                    size="small"
                    onClick={() => setPrecautionDialogOpen(true)}
                    sx={{
                      mt: 1,
                      textTransform: 'none',
                      fontWeight: 600,
                      borderWidth: 2,
                      '&:hover': {
                        borderWidth: 2,
                        transform: 'scale(1.02)',
                        boxShadow: '0 4px 12px rgba(255, 152, 0, 0.3)'
                      },
                      transition: 'all 0.2s ease'
                    }}
                  >
                  ⚠️ Special Precaution
                </Button>
            </Box>
          </Stack>
        </Grid>

       
    
        <Grid item xs={12} md={3} size={3}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h6" fontWeight={700} color="primary">
              Vital Signs
            </Typography>
           
          </Box>
         <Stack spacing={1}>
            <Typography variant="body2">
                <strong>Temperature:</strong> {selectedPatient?.vitals?.temperature ?? "-"}°C
                </Typography>

                <Typography variant="body2">
                <strong>Blood Pressure:</strong> {selectedPatient?.vitals?.bp ?? "-"} mmHg
                </Typography>

                <Typography variant="body2">
                <strong>Pulse:</strong> {selectedPatient?.vitals?.pulse ?? "-"} bpm
                </Typography>
                    
                <Typography variant="body2">
                <strong>Respiration Rate:</strong> {selectedPatient?.vitals?.respiration ?? "-"} breaths/min
                </Typography>

          </Stack>
        </Grid>
        <Grid item xs={12} md={3} >

          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h6" fontWeight={700} color="primary">
              
            </Typography>
            <IconButton
              color="primary"
              size="small"
              onClick={() => setVitalsHistoryOpen(true)}
              title="View Vital Signs History"
              sx={{
                bgcolor: 'primary.main',
                color: 'white',
                '&:hover': {
                  bgcolor: 'primary.dark',
                }
              }}
            >
              <History />
            </IconButton>
          </Box>
         
          <Stack spacing={1}>
            
            <Typography variant="body2">
              <strong> Weight:</strong> {selectedPatient?.vitals?.weight ??  "-"} kg
            </Typography>
            <Typography variant="body2">
              <strong>Height:</strong> {selectedPatient?.vitals?.height ??  "-"} cm
            </Typography>
             <Typography variant="body2">
                <strong>BMI:</strong> {selectedPatient?.vitals?.bmi ?? "-"}
                </Typography>
           
          </Stack>
        </Grid>

      </Grid>
    </Box>

   <CardContent sx={{ p: 1.25, "&:last-child": { pb: 1.25 } }}>
    <Box sx={{
      display: "grid",
      gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
      gap: 1,
    }}>
      {/* Admission Details — single line */}
      <Box sx={{
        p: 1, borderRadius: 1.5,
        border: "1px solid #cfe1ff",
        bgcolor: "rgba(33,150,243,0.06)",
        display: "flex", flexWrap: "wrap", alignItems: "center", columnGap: 1.25, rowGap: 0.25,
      }}>
        <Typography sx={{ fontSize: "0.7rem", fontWeight: 800, letterSpacing: "0.5px", textTransform: "uppercase", color: "#1e40af", mr: 0.5 }}>
          Admission
        </Typography>
        {[
          { label: "At",   value: admiAT },
          { label: "By",   value: admit_by },
          { label: "On",   value: admmission_note },
        ].map(i => (
          <Typography key={i.label} sx={{ fontSize: "0.78rem", color: "#0f172a" }}>
            <Box component="span" sx={{ color: "#64748b", fontWeight: 700 }}>{i.label}:</Box> {i.value || "—"}
          </Typography>
        ))}
      </Box>

      {/* Clinical Category — single line */}
      <Box sx={{
        p: 1, borderRadius: 1.5,
        border: "1px solid #ffd9b3",
        bgcolor: "rgba(255,152,0,0.06)",
        display: "flex", flexWrap: "wrap", alignItems: "center", columnGap: 1.25, rowGap: 0.25,
      }}>
        <Typography sx={{ fontSize: "0.7rem", fontWeight: 800, letterSpacing: "0.5px", textTransform: "uppercase", color: "#92400E", mr: 0.5 }}>
          Clinical
        </Typography>
        {[
          { label: "Attendance", value: attendanceType },
          { label: "Diagnosis",  value: Diagnosis },
          { label: "Procedure",  value: procedure_ },
        ].map(i => (
          <Typography key={i.label} sx={{ fontSize: "0.78rem", color: "#0f172a" }}>
            <Box component="span" sx={{ color: "#64748b", fontWeight: 700 }}>{i.label}:</Box> {i.value || "—"}
          </Typography>
        ))}
      </Box>
    </Box>
  </CardContent>
  </Card>
  </Collapse>
)}



 {selectedPatient && (
  <ComplianceBanner
    patientId={selectedPatient.id}
    admissionDate={selectedPatient.admissionDate || selectedPatient.visitDate || ''}
    refreshKey={complianceRefreshKey}
  />
 )}

 {selectedPatient ? (
  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, minHeight: '70vh', gap: { sm: 2 } }}>
    <Paper
      elevation={0}
      sx={{
        width: { xs: '100%', sm: 68, md: 68 },
        flexShrink: 0,
        borderRadius: 2,
        border: '1px solid #e5e9ef',
        bgcolor: '#fff',
        mb: { xs: 2, sm: 0 },
        maxHeight: { sm: '78vh' },
        overflow: 'auto',
        transition: 'width 0.25s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s ease',
        opacity: selectedPatient.state === 'Discharge' ? 0.5 : 1,
        pointerEvents: selectedPatient.state === 'Discharge' ? 'none' : 'auto',
        position: { sm: 'sticky' },
        top: { sm: 16 },
        alignSelf: { sm: 'flex-start' },
        '&:hover': {
          width: { sm: 240, md: 260 },
          boxShadow: '0 8px 24px rgba(15,23,42,0.08)',
          '& .MuiTab-root': {
            fontSize: { sm: '0.85rem' },
            justifyContent: { sm: 'flex-start' },
            paddingLeft: { sm: '20px' },
            '& .MuiTab-iconWrapper': {
              marginRight: { sm: '14px' },
            },
          },
          '& .ward-tab-section-label': {
            opacity: 1, maxHeight: 30, paddingTop: '14px',
          },
        },
      }}
    >
      {/* Section label visible only when expanded */}
      <Box className="ward-tab-section-label" sx={{
        opacity: 0,
        maxHeight: 0,
        overflow: 'hidden',
        px: 2.5,
        pb: 0.5,
        transition: 'opacity 0.18s ease, max-height 0.25s ease, padding 0.25s ease',
      }}>
        <Typography sx={{
          fontSize: '0.62rem', fontWeight: 700,
          color: '#94a3b8', letterSpacing: '1.2px', textTransform: 'uppercase',
          whiteSpace: 'nowrap',
        }}>
          Patient Care
        </Typography>
      </Box>

      <Tabs
        value={activeTab}
        onChange={(e, v) => {
           if (selectedPatient.state === 'Discharge') return;
          if (!ensureServiceAndAttendanceSelected()) return;
          setActiveTab(v);
        }}
        orientation="vertical"
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        TabIndicatorProps={{ sx: { display: 'none' } }}
        sx={{
          '& .MuiTabs-flexContainer': { gap: '2px', px: '6px', py: '6px' },
          '& .MuiTab-root': {
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: { xs: '100%', sm: 56, md: 56 },
            minHeight: { xs: 48, sm: 52, md: 52 },
            fontSize: { xs: '0.78rem', sm: '0' },
            padding: { xs: '10px 14px', sm: '10px' },
            borderRadius: '10px',
            color: '#64748b',
            textTransform: 'none',
            transition: 'background-color 0.15s ease, color 0.15s ease, padding 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            position: 'relative',
            '& .MuiTab-iconWrapper': {
              marginBottom: { xs: 0, sm: 0 },
              marginRight: { xs: '10px', sm: 0 },
              fontSize: 22,
            },
            '&:hover': {
              backgroundColor: 'rgba(15,23,42,0.04)',
              color: '#334155',
            },
            '&.Mui-selected': {
              backgroundColor: 'rgba(26,155,127,0.10)',
              color: '#1A9B7F',
              fontWeight: 700,
              '&::before': {
                content: '""',
                position: 'absolute',
                left: 0, top: '22%', bottom: '22%',
                width: 3,
                borderRadius: '0 3px 3px 0',
                bgcolor: '#1A9B7F',
              },
              '&:hover': { backgroundColor: 'rgba(26,155,127,0.16)' },
            },
          },
        }}
      >
        <Tab
          label="Information/ Note"
          icon={<LocalHospital />}
          iconPosition="start"
        />
        
        <Tab
          label="Consumables"
          icon={<RoomService />}
          iconPosition="start"
        />
        <Tab
          label="Nurses Note"
          icon={<CalendarMonth />}
          iconPosition="start"
        />

      <Tab
        label="Patient Vitals"
        icon={<MonitorHeartIcon />}
        iconPosition="start"
      />

      <Tab
        label="Blood Sugar"
        icon={<Science />}
        iconPosition="start"
      />

      <Tab
        label="Medication Chart"
        icon={<Medication />}
        iconPosition="start"
      />

      <Tab
        label="Bed & Ward Transfer"
        icon={<PersonAdd />}
        iconPosition="start"
      />


      </Tabs>
    </Paper>

      <Paper
      elevation={0}
      sx={{
        flexGrow: 1,
        p: { xs: 1.25, sm: 1.5 },
        borderRadius: 2,
        border: '1px solid #e5e9ef',
        bgcolor: '#fff',
        minWidth: 0,
        opacity: selectedPatient.state === 'Discharge' ? 0.5 : 1,
        pointerEvents: selectedPatient.state === 'Discharge' ? 'none' : 'auto',
      }}>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 0.75,
          mb: 1.25,
          justifyContent: "flex-start",
        }}
      >
        <Tooltip title="View full medical record history">
          <Button
          size="small"
          variant="outlined"
          color="primary"
          onClick={() => setMedHistoryOpen(true)}
          startIcon={<Notes />}
        >
          Medical History
        </Button>
        </Tooltip>

         <Tooltip title="Review past Vitals results">
          <Button
            size="small"
            variant="outlined"
            color="success"

            startIcon={<History />}
             onClick={() => setVitalsHistoryOpen(true)}
          >
            Vitals History
          </Button>
        </Tooltip>

        <Tooltip title="Review past laboratory results">
          <Button
            size="small"
            variant="outlined"
            color="secondary"

            startIcon={<Science />}
             onClick={() => setlabHistoryOpen(true)}
          >
            Lab History
          </Button>
        </Tooltip>

        <Tooltip title="View previous scan/imaging results">
          <Button
            size="small"
            variant="outlined"
            color="info"
             onClick={() => setScanHistoryOpen(true)}
            startIcon={<CameraAlt />}
          >
            Scan History
          </Button>
        </Tooltip>

        <Tooltip title="Check previous medications prescribed">
          <Button
            size="small"
            variant="outlined"
            color="success"
            onClick={() => setopenmedHis(true)}
            startIcon={<Medication />}
          >
            Medication History
          </Button>
        </Tooltip>


      </Box>

       <Grid item xs={12} size={12}>
          <Card 
            sx={{ 
              borderRadius: 2, 
              boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
              overflow: 'hidden',
              border: '1px solid rgba(0,0,0,0.08)',
              bgcolor: '#fafafa'
            }}
          >
            <Box 
              sx={{ 
                background: '#ffffff',
                borderBottom: '1px solid rgba(0,0,0,0.08)',
                
                color: '#37474f'
              }}
            >
              <Typography variant="h6" fontWeight={500} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <LocalHospitalIcon sx={{ color: '#546e7a' }} />
                Admission History / Results 
              </Typography>
            </Box>

            <CardContent sx={{bgcolor: '#ffffff' }}>
              <Box 
                sx={{ 
                  display: 'grid',
                  gridTemplateColumns: {
                    xs: '1fr',
                    sm: 'repeat(2, 1fr)',
                    md: 'repeat(4, 1fr)'
                  },
                  gap: 2
                }}
              >
                {historyButtons.map((btn, index) => (
                  <Button
                    key={index}
                    variant="outlined"
                    onClick={btn.onClick}
                    startIcon={btn.icon}
                    sx={{
                      background: '#ffffff',
                      color: '#546e7a',
                      borderRadius: 1,
                      textTransform: 'none',
                      fontWeight: 300,
                     
                      border: '1px solid #e0e0e0',
                      boxShadow: 'none',
                      '&:hover': {
                        background: '#f5f5f5',
                        borderColor: '#9e9e9e',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                      },
                      transition: 'all 0.2s ease',
                      '& .MuiButton-startIcon': {
                        
                        color: '#78909c'
                      }
                    }}
                  >
                    {btn.label}
                  </Button>
                ))}
                
              </Box>
            </CardContent>
          </Card>
       </Grid>
   
{activeTab === 0 && (
  <Box>
    <Box sx={{ p: 3, bgcolor: '#f5f5f5', minHeight: '50vh' }}>
    <Paper sx={{ p: 4, maxWidth: 1400, mx: 'auto' }}>

      <Box
        sx={{
          display: 'grid',
          gap: 3,
          alignItems: 'start',
          gridTemplateColumns: {
            xs: '1fr',
            md: '1fr 1fr',
            lg: '1fr 1fr 1fr',
            xl: '1fr 1fr 1fr 1fr'
          }
        }}
      >
        <Box
          sx={{
            border: '2px solid #e0e0e0',
            borderRadius: 2,
            p: 2.5,
            bgcolor: '#fafafa',
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              mb: 2.5,
              color: '#1976d2',
              borderBottom: '2px solid #1976d2',
              pb: 1,
              flexShrink: 0
            }}
          >
            Complaint
          </Typography>

          <Box sx={{ maxHeight: 300, overflowY: 'auto', pr: 1 }}>
            {wardRoundsData.map((entry, index) => (
              <Box
                key={index}
                sx={{
                  mb: 3,
                  pb: 2.5,
                  borderBottom:
                    index < wardRoundsData.length - 1 ? '1px solid #e0e0e0' : 'none'
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: '1rem',
                    fontWeight: 700,
                    color: '#1976d2',
                    textDecoration: 'underline',
                    mb: 1.5
                  }}
                >
                  {entry.date}
                </Typography>

                <Typography
                  sx={{
                    whiteSpace: 'pre-wrap',
                    lineHeight: 1.7,
                    fontSize: '0.9rem',
                    color: '#333'
                  }}
                >
                  {entry.complaint}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        <Box
          sx={{
            border: '2px solid #e0e0e0',
            borderRadius: 2,
            p: 2.5,
            bgcolor: '#fafafa',
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              mb: 2.5,
              color: '#2e7d32',
              borderBottom: '2px solid #2e7d32',
              pb: 1,
              flexShrink: 0
            }}
          >
            Physical Examination
          </Typography>

          <Box sx={{ maxHeight: 300, overflowY: 'auto', pr: 1 }}>
            {wardRoundsData.map((entry, index) => (
              <Box
                key={index}
                sx={{
                  mb: 3,
                  pb: 2.5,
                  borderBottom:
                    index < wardRoundsData.length - 1 ? '1px solid #e0e0e0' : 'none'
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: '1rem',
                    fontWeight: 700,
                    color: '#2e7d32',
                    textDecoration: 'underline',
                    mb: 1.5
                  }}
                >
                  {entry.date}
                </Typography>

                <Typography
                  sx={{
                    whiteSpace: 'pre-wrap',
                    lineHeight: 1.7,
                    fontSize: '0.9rem',
                    color: '#333'
                  }}
                >
                  {entry.physicalExam}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        <Box
          sx={{
            border: '2px solid #e0e0e0',
            borderRadius: 2,
            p: 2.5,
            bgcolor: '#fafafa',
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              mb: 2.5,
              color: '#ed6c02',
              borderBottom: '2px solid #ed6c02',
              pb: 1,
              flexShrink: 0
            }}
          >
            Other Documentation
          </Typography>

          <Box sx={{ maxHeight: 300, overflowY: 'auto', pr: 1 }}>
            {wardRoundsData.map((entry, index) => (
              <Box
                key={index}
                sx={{
                  mb: 3,
                  pb: 2.5,
                  borderBottom:
                    index < wardRoundsData.length - 1 ? '1px solid #e0e0e0' : 'none'
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: '1rem',
                    fontWeight: 700,
                    color: '#ed6c02',
                    textDecoration: 'underline',
                    mb: 1.5
                  }}
                >
                  {entry.date}
                </Typography>

                <Typography
                  sx={{
                    whiteSpace: 'pre-wrap',
                    lineHeight: 1.7,
                    fontSize: '0.9rem',
                    color: '#333'
                  }}
                >
                  {entry.otherDocumentation}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        <Box
          sx={{
            border: '2px solid #e0e0e0',
            borderRadius: 2,
            p: 2.5,
            bgcolor: '#fafafa',
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              mb: 2.5,
              color: '#d32f2f',
              borderBottom: '2px solid #d32f2f',
              pb: 1,
              flexShrink: 0
            }}
          >
            Surgical Notes
          </Typography>

          <Box sx={{ maxHeight: 300, overflowY: 'auto', pr: 1 }}>
            {wardRoundsData.map((entry, index) => (
              <Box
                key={index}
                sx={{
                  mb: 3,
                  pb: 2.5,
                  borderBottom:
                    index < wardRoundsData.length - 1 ? '1px solid #e0e0e0' : 'none'
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: '1rem',
                    fontWeight: 700,
                    color: '#d32f2f',
                    textDecoration: 'underline',
                    mb: 1.5
                  }}
                >
                  {entry.date}
                </Typography>

                <Typography
                  sx={{
                    whiteSpace: 'pre-wrap',
                    lineHeight: 1.7,
                    fontSize: '0.9rem',
                    color: '#333'
                  }}
                >
                  {entry.surgicalNotes}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

      <Box
      sx={{
        border: '2px solid #e0e0e0',
        borderRadius: 2,
        p: 2.5,
        bgcolor: '#fafafa',
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          mb: 2.5,
          color: '#336327ff',
          borderBottom: '2px solid #9fd81cff',
          pb: 1,
          flexShrink: 0
        }}
      >
        Doctors Plan
      </Typography>

      <Box sx={{ maxHeight: 300, overflowY: 'auto', pr: 1 }}>
        {wardRoundsData.map((entry, index) => (
          <Box
            key={index}
            sx={{
              mb: 3,
              pb: 2.5,
              borderBottom:
                index < wardRoundsData.length - 1 ? '1px solid #e0e0e0' : 'none'
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: '1rem',
                fontWeight: 700,
                color: '#475a19ff',
                textDecoration: 'underline',
                mb: 1.5
              }}
            >
              {entry.date}
            </Typography>

            <Typography
              sx={{
                whiteSpace: 'pre-wrap',
                lineHeight: 1.7,
                fontSize: '0.9rem',
                color: '#333'
              }}
            >
              {entry.plan}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>

      <Box
        sx={{
          border: '2px solid #e0e0e0',
          borderRadius: 2,
          p: 2.5,
          bgcolor: '#fafafa',
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            mb: 2.5,
            color: '#6a1b9a',
            borderBottom: '2px solid #6a1b9a',
            pb: 1,
            flexShrink: 0
          }}
        >
          Diagnosis & Procedure(s)
        </Typography>

        <Box sx={{ maxHeight: 300, overflowY: 'auto', pr: 1 }}>

          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, mb: 1 }}
          >
            Diagnosis(es)
          </Typography>

          {selectedDiagnoses?.length > 0 ? (
            <Box sx={{ ml: 1 }}>
              {selectedDiagnoses.map((diag, idx) => (
                <Typography
                  key={idx}
                  sx={{
                    mb: 1,
                    fontSize: '0.9rem',
                    lineHeight: 1.6,
                    color: '#333'
                  }}
                >
                  • <strong>{diag.code}</strong> — {diag.name}
                </Typography>
              ))}
            </Box>
          ) : (
            <Typography sx={{ fontSize: '0.85rem', color: '#999', ml: 1 }}>
              No diagnosis recorded.
            </Typography>
          )}

          <Divider sx={{ my: 2 }} />

          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, mb: 1 }}
          >
            Procedure(s)
          </Typography>

          {selectedProcedures?.length > 0 ? (
            <Box sx={{ ml: 1 }}>
              {selectedProcedures.map((proc, idx) => (
                <Typography
                  key={idx}
                  sx={{
                    mb: 1,
                    fontSize: '0.9rem',
                    lineHeight: 1.6,
                    color: '#333'
                  }}
                >
                  • {proc.name}
                </Typography>
              ))}
            </Box>
          ) : (
            <Typography sx={{ fontSize: '0.85rem', color: '#999', ml: 1 }}>
              No procedure recorded.
            </Typography>
          )}

        </Box>
      </Box>


      </Box>

    </Paper>
  </Box>

  

  </Box>
  

  
)}



{/* consumables */}
{activeTab === 1 && (
  <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
    {/* --- Available Services (Left) --- */}
    <Grid item xs={12} md={6} size={6}>
      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold">
          Available Non Insured Services
        </Typography>

        <TextField
          fullWidth
          placeholder="Search  Non Insured Services by name..."
          value={serviceSearchTerm}
          onChange={(e) => setServiceSearchTerm(e.target.value)}
          sx={{ mb: 2 }}
          size="big"
        />
        

        <TableContainer sx={{ maxHeight: 400, overflowX: "auto" }}>
          <Table stickyHeader size="small">
           <TableHead>
            <TableRow>
              <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Service</TableCell>
              <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Quantity</TableCell>
              <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Amount</TableCell>
              <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }} align="center">
                Request
              </TableCell>
            </TableRow>
          </TableHead>

           <TableBody>
          {services
            .filter((srv) =>
              srv.name.toLowerCase().includes(serviceSearchTerm.toLowerCase())
            )
            .slice(servicePage * serviceRowsPerPage, servicePage * serviceRowsPerPage + serviceRowsPerPage)
            .map((srv, idx) => {
              const key = `${srv.name}-${idx}`;
              const quantity = serviceQuantities[key] || 1;
              const finalAmount = srv.amount * quantity;

              return (
                <TableRow key={key}>
                  {/* Service Name */}
                  <TableCell>{srv.name}</TableCell>

                  {/* Quantity Input */}
                  <TableCell>
                    <TextField
                      type="number"
                      size="small"
                      value={quantity}
                      inputProps={{ min: 1 }}
                      onChange={(e) => {
                        const val = Math.max(1, Number(e.target.value));
                        setServiceQuantities((prev) => ({ ...prev, [key]: val }));
                      }}
                      sx={{ width: 80 }}
                    />
                  </TableCell>

                  {/* Auto-updated Amount */}
                  <TableCell>{formatWithOutSom(finalAmount)}</TableCell>

                  {/* Request Button */}
                  <TableCell align="center">
                    <IconButton
                      color="primary"
                      onClick={() =>
                        handleRequestService({
                          ...srv,
                          amount: finalAmount,     // 👈 send multiplied amount
                          quantity,
                          
                        })
                      }
                    >
                      <Send />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>

          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={services.filter((srv) =>
            srv.name.toLowerCase().includes(serviceSearchTerm.toLowerCase())
          ).length}
          page={servicePage}
          onPageChange={(e, newPage) => setServicePage(newPage)}
          rowsPerPage={serviceRowsPerPage}
          onRowsPerPageChange={(e) => {
            setServiceRowsPerPage(parseInt(e.target.value, 10));
            setServicePage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Paper>
    </Grid>

    {/* --- Requested Services (Right) --- */}
    <Grid item xs={12} md={6} size={6}>
      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold">
          Requested Services
        </Typography>

        <TableContainer sx={{ maxHeight: 400, overflowX: "auto" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Date</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Service</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Amount</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Requested By</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Status</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Paid By</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requestedServices
                .slice(
                  reqServicePage * reqServiceRowsPerPage,
                  reqServicePage * reqServiceRowsPerPage + reqServiceRowsPerPage
                )
                .map((req, idx) => (
                  <TableRow
                    key={idx}
                    sx={{ "&:nth-of-type(odd)": { backgroundColor: "action.hover" } }}
                  >
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.date}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.service}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{ formatWithOutSom(req.amount)}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.requestedBy}</TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        label={req.status}
                        color={req.status === "paid" ? "success" : "warning"}
                        sx={{ fontSize: "0.7rem" }}
                      />
                    </TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.servicedBy || "-"}</TableCell>
                    <TableCell>
                      {req.date?.substring(0, 10) === currentDate ? (
                        // ✅ Today — allow deletion
                        <IconButton
                          color="error"
                          size="small"
                          onClick={() => handleDeleteServiceRequest(req)}
                        >
                          <Close fontSize="small" />
                        </IconButton>
                      ) : (
                        // 🔒 Not Today — disable and show tooltip
                        <Tooltip title="Cannot delete past service requests">
                          <span>
                            <IconButton color="disabled" size="small" disabled>
                              <LockIcon fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>
                      )}
                    </TableCell>

                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={requestedServices.length}
          page={reqServicePage}
          onPageChange={(e, newPage) => setReqServicePage(newPage)}
          rowsPerPage={reqServiceRowsPerPage}
          onRowsPerPageChange={(e) => {
            setReqServiceRowsPerPage(parseInt(e.target.value, 10));
            setReqServicePage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />

        {/* Totals */}
        <Box
          sx={{
            mt: 2,
            p: 1.5,
            borderRadius: 2,
            background: "linear-gradient(90deg, #e1f5fe, #f1f8e9)",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="caption" fontWeight="bold" color="warning.main">
            Total Pending: GH₵{" "}
            {formatWithOutSom(requestedServices
              .filter((r) => r.status === "pending")
              .reduce((sum, r) => sum + Number(r.amount), 0))}
          </Typography>

          <Typography variant="caption" fontWeight="bold" color="success.main">
            Total Paid: GH₵{" "}
            {formatWithOutSom(requestedServices
              .filter((r) => r.status === "paid")
              .reduce((sum, r) => sum + Number(r.amount), 0))}
          </Typography>

        </Box>
      </Paper>
    </Grid>
  </Grid>
)}

{activeTab === 2 && selectedPatient && (
  <>
    <Tooltip title="Generate AI nurse note from this patient's data" arrow placement="left">
      <Fab
        color="primary"
        onClick={() => setAiNoteDialogOpen(true)}
        sx={{
          position: 'fixed',
          bottom: 28,
          right: 28,
          zIndex: 1200,
          bgcolor: '#41a386',
          color: 'white',
          boxShadow: '0 10px 24px rgba(65,163,134,0.35)',
          '&:hover': { bgcolor: '#2f8068' },
        }}
      >
        <AutoAwesome />
      </Fab>
    </Tooltip>
    <AINurseNoteDialog
      open={aiNoteDialogOpen}
      onClose={() => setAiNoteDialogOpen(false)}
      patient={selectedPatient}
      complaint={complaint}
      history={history}
      exam={exam}
      other={other}
      diagnoses={selectedDiagnoses}
      procedures={selectedProcedures}
      vitalsHistory={vitalsHistory}
      chartedMedications={chartedMedications}
      wardRoundsData={wardRoundsData}
      onGenerated={(text) => setNurseNoteText(text)}
    />
  </>
)}

{activeTab === 2 && (
  <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
    <Grid item xs={12} md={4} size={3}>
      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3, height: 600, display: 'flex', flexDirection: 'column' }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold" sx={{ mb: 2, flexShrink: 0 }}>
          Note History
        </Typography>

        {nurseNotes.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Notes sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
            <Typography variant="body2" color="text.secondary">
              No notes recorded yet
            </Typography>
          </Box>
        ) : (
          <Box 
            sx={{ 
              flex: 1,
              overflowY: 'auto',
              overflowX: 'hidden',
              pr: 1,
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: '#f1f1f1',
                borderRadius: '10px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#888',
                borderRadius: '10px',
                '&:hover': {
                  backgroundColor: '#555',
                }
              }
            }}
          >
            {nurseNotes.map((note, idx) => (
              <Card
                key={idx}
                sx={{
                  mb: 2,
                  border: selectedNote?.trans_code === note.trans_code ? '2px solid' : '1px solid',
                  borderColor: selectedNote?.trans_code === note.trans_code ? 'primary.main' : 'divider',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-2px)'
                  }
                }}
                onClick={() => handleSelectNote(note)}
              >
                <CardContent sx={{ p: 2 }}>
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                    <Typography variant="subtitle2" fontWeight="bold" color="primary">
                      {note.dat}
                    </Typography>
                    <Chip
                      size="small"
                      label={note.time}
                      color="info"
                      sx={{ fontSize: '0.7rem' }}
                    />
                  </Box>
                  
                  <Box display="flex" alignItems="center" gap={1} mb={1}>
                    <Avatar sx={{ width: 24, height: 24, bgcolor: 'secondary.main', fontSize: '0.8rem' }}>
                      {note.user?.charAt(0) || 'N'}
                    </Avatar>
                    <Typography variant="body2" color="text.secondary">
                      {note.user}
                    </Typography>
                  </Box>

                  <Typography
                    variant="body2"
                    sx={{
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      color: 'text.secondary',
                      fontSize: '0.85rem'
                    }}
                  >
                    {note.note}
                  </Typography>

                  {note.user === currentUser && (
                    <Chip
                      size="small"
                      label="You can edit"
                      color="success"
                      icon={<Edit />}
                      sx={{ mt: 1, fontSize: '0.7rem' }}
                    />
                  )}
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
      </Paper>
    </Grid>

    <Grid item xs={12} md={8} size={9}>
    <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 3, minHeight: 500 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1} gap={1} flexWrap="wrap">
        <Typography variant="h6" fontWeight="bold">
            {selectedNote
            ? (selectedNote.user === currentUser ? 'Edit Your Note' : 'View Note')
            : 'New Nurse Note'}
        </Typography>

        <Box display="flex" alignItems="center" gap={1}>
          {selectedNote && (
            <>
              <Chip
                  label={`By: ${selectedNote.user}`}
                  color="primary"
                  size="small"
              />
              <Chip
                  label={`${selectedNote.dat} ${selectedNote.time}`}
                  color="info"
                  size="small"
              />
            </>
          )}
          {/* Backfill: opens the per-day table in a dialog. Red badge
              surfaces the number of days below the per-day minimum. */}
          <ComplianceNotesBackfill
            patient={{
              id: selectedPatient.id,
              fullName: selectedPatient.fullName,
              age: selectedPatient.age,
              gender: selectedPatient.gender,
            }}
            admissionDate={selectedPatient.admissionDate || selectedPatient.visitDate || ''}
            currentUser={currentUser}
            notesHistory={nurseNotes}
            onSaved={() => {
              loadNurseNotes();
              setComplianceRefreshKey(k => k + 1);
            }}
          />
        </Box>
        </Box>

        <Divider sx={{ mb: 1 }} />

        {selectedNote && selectedNote.user === currentUser && selectedNote.dat === currentDate && (
        <Box sx={{ mb: 2, p: 2, bgcolor: 'warning.lighter', borderRadius: 1, border: '1px solid', borderColor: 'warning.main' }}>
            <Typography variant="body2" color="warning.dark" fontWeight={600}>
            ℹ️ You are editing your note for today. Clicking save will update this existing note.
            </Typography>
        </Box>
        )}

        <TextField
        fullWidth
        multiline
        rows={15}
        value={nurseNoteText}
        onChange={(e) => setNurseNoteText(e.target.value)}
        placeholder="Enter nurse note here... Document patient observations, vital signs, medications administered, treatments provided, and any significant changes in patient condition."
        disabled={selectedNote && selectedNote.user !== currentUser}
        sx={{
            mb: 3,
            '& .MuiInputBase-root': {
            fontSize: '1rem',
            lineHeight: 1.8
            },
            '& .MuiInputBase-input.Mui-disabled': {
            WebkitTextFillColor: '#000',
            opacity: 1,
            }
        }}
        />

        <Stack direction="row" spacing={2} justifyContent="space-between">
        <Box>
            {selectedNote && selectedNote.user === currentUser && (
            <Button
                variant="outlined"
                color="error"
                startIcon={<Delete />}
                onClick={() => handleDeleteNurseNote(selectedNote)}
            >
                Delete Note
            </Button>
            )}
        </Box>

        <Box display="flex" gap={2} alignItems="center" flexWrap="wrap">
            {selectedNote && selectedNote.user !== currentUser ? (
            <Box display="flex" alignItems="center" gap={1}>
                <LockIcon color="error" />
                <Typography variant="body2" color="error">
                You cannot edit notes written by other nurses
                </Typography>
            </Box>
            ) : (
            <>
                <Button
                variant="outlined"
                color="secondary"
                startIcon={<Close />}
                onClick={handleClearNurseNote}
                >
                Clear
                </Button>

                <Button
                variant="contained"
                color="primary"
                startIcon={<SaveIcon />}
                onClick={handleSaveNurseNote}
                disabled={!nurseNoteText.trim()}
                >
                {selectedNote && selectedNote.user === currentUser && selectedNote.dat === currentDate
                    ? 'Update Note'
                    : 'Save Note'}
                </Button>
            </>
            )}
        </Box>
        </Stack>

        <Box sx={{ mt: 3, p: 2, bgcolor: 'info.lighter', borderRadius: 1 }}>
        <Typography variant="caption" color="text.secondary">
            <strong>Note:</strong> Each nurse can have only ONE note per day for each patient.
            Saving a new note today will update your existing note for today if one exists.
            You cannot edit notes written by other nurses.
        </Typography>
        </Box>
    </Paper>
    </Grid>
  </Grid>
)}

{/* Patient Vitals — record + history. Existing handlers
    (loadVitalsHistory, handleSaveVitals, handleDeleteVitals,
    handleSelectVital, handleClearVitals, calculateBMI) kept their original
    shape; only the JSX surface is rebuilt here. */}
{activeTab === 3 && (
  <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
    {/* Left — history list */}
    <Grid item xs={12} md={4} size={4}>
      <Paper sx={{ p: 1.5, borderRadius: 2, border: '1px solid #e5e9ef', height: 600, display: 'flex', flexDirection: 'column' }}>
        <Typography sx={{ fontSize: '0.92rem', fontWeight: 800, color: '#0f172a', mb: 0.75 }}>
          Vitals History
        </Typography>
        <Divider sx={{ mb: 1 }} />
        {(!vitalsHistory || vitalsHistory.length === 0) ? (
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#94a3b8' }}>
            <MonitorHeartIcon sx={{ fontSize: 36, mb: 1, color: '#cbd5e1' }} />
            <Typography sx={{ fontSize: '0.82rem' }}>No vitals recorded yet</Typography>
          </Box>
        ) : (
          <Box sx={{ flex: 1, overflowY: 'auto', pr: 0.5 }}>
            <Stack spacing={0.6}>
              {vitalsHistory.map((v) => {
                const active = selectedVital?.trans_code === v.trans_code;
                return (
                  <Paper key={v.trans_code} elevation={0}
                    onClick={() => handleSelectVital(v)}
                    sx={{
                      p: 1, cursor: 'pointer',
                      border: '1px solid', borderColor: active ? '#1A9B7F' : '#e5e9ef',
                      borderLeft: '3px solid', borderLeftColor: active ? '#1A9B7F' : 'transparent',
                      bgcolor: active ? 'rgba(26,155,127,0.08)' : '#fff',
                      borderRadius: 1.5,
                      transition: 'all .15s ease',
                      '&:hover': { borderColor: '#1A9B7F', bgcolor: '#f8fafc' },
                    }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography sx={{ fontSize: '0.78rem', fontWeight: 700, color: '#0f172a' }}>
                        {v.dat_vist}{v.time ? ` · ${v.time}` : ''}
                      </Typography>
                      {/* Only the user who recorded the vital can delete it */}
                      {v.user === currentUser ? (
                        <IconButton size="small"
                          onClick={(e) => { e.stopPropagation(); handleDeleteVitals(v); }}
                          sx={{ p: 0.25, color: '#dc2626' }}>
                          <Delete sx={{ fontSize: 14 }} />
                        </IconButton>
                      ) : (
                        <Tooltip title={`Recorded by ${v.user || '—'} — only the recorder can delete`} arrow>
                          <Box sx={{ p: 0.25, color: '#cbd5e1', display: 'flex' }}>
                            <LockIcon sx={{ fontSize: 14 }} />
                          </Box>
                        </Tooltip>
                      )}
                    </Box>
                    <Typography sx={{ fontSize: '0.7rem', color: '#475569', mt: 0.25 }}>
                      T {v.tem || '—'} · P {v.pulse || '—'} · BP {v.pre || '—'} · RR {v.res || '—'} · SpO₂ {v.spo2 || '—'}
                    </Typography>
                    <Typography sx={{ fontSize: '0.62rem', color: '#94a3b8', mt: 0.25 }}>
                      by {v.user || '—'}
                    </Typography>
                  </Paper>
                );
              })}
            </Stack>
          </Box>
        )}
      </Paper>
    </Grid>

    {/* Right — record / edit form */}
    <Grid item xs={12} md={8} size={8}>
      {(() => {
        // Selected vital is locked (read-only) if it was recorded by someone
        // other than the current user. Same rule as Nurse Notes.
        const vitalLocked = !!selectedVital && selectedVital.user !== currentUser;
        return (
      <Paper sx={{ p: 1.75, borderRadius: 2, border: '1px solid #e5e9ef', mb: 1.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1, flexWrap: 'wrap', gap: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
            <Typography sx={{ fontSize: '0.92rem', fontWeight: 800, color: '#0f172a' }}>
              {selectedVital ? (vitalLocked ? 'View Vitals' : 'Update Vitals') : 'Record New Vitals'}
            </Typography>
            {vitalLocked && (
              <Chip size="small" icon={<LockIcon sx={{ fontSize: 14 }} />}
                label={`Read-only · by ${selectedVital.user || '—'}`}
                sx={{
                  height: 20, fontSize: '0.66rem', fontWeight: 700,
                  bgcolor: '#f1f5f9', color: '#475569',
                  '& .MuiChip-icon': { color: '#94a3b8' },
                }} />
            )}
          </Box>
          {selectedVital && (
            <Button size="small" onClick={handleClearVitals}
              sx={{ textTransform: 'none', color: '#64748b', fontWeight: 700 }}>
              + New
            </Button>
          )}
        </Box>
        <Divider sx={{ mb: 1.5 }} />
        <Grid container spacing={1.25} columns={{ xs: 4, sm: 8, md: 12 }}>
          <Grid item xs={6} sm={4} md={4} size={4}>
            <TextField fullWidth size="small" label="Temperature (°C) *"
              type="number" value={vitalData.tem}
              onChange={(e) => setVitalData({ ...vitalData, tem: e.target.value })}
              error={vitalErrors.tem}
              disabled={vitalLocked}
              helperText={vitalErrors.tem ? 'Required, 30–45 °C' : ' '} />
          </Grid>
          <Grid item xs={6} sm={4} md={4} size={4}>
            <TextField fullWidth size="small" label="Pulse (bpm)"
              type="number" value={vitalData.pulse}
              onChange={(e) => setVitalData({ ...vitalData, pulse: e.target.value })}
              error={vitalErrors.pulse}
              disabled={vitalLocked}
              helperText={vitalErrors.pulse ? '40–200 bpm' : ' '} />
          </Grid>
          <Grid item xs={6} sm={4} md={4} size={4}>
            <TextField fullWidth size="small" label="Resp Rate (/min)"
              type="number" value={vitalData.res}
              onChange={(e) => setVitalData({ ...vitalData, res: e.target.value })}
              error={vitalErrors.res}
              disabled={vitalLocked}
              helperText={vitalErrors.res ? '8–40 /min' : ' '} />
          </Grid>
          <Grid item xs={6} sm={4} md={4} size={4}>
            <TextField fullWidth size="small" label="Blood Pressure (mmHg)"
              placeholder="120/80"
              value={vitalData.pre}
              onChange={(e) => setVitalData({ ...vitalData, pre: e.target.value })}
              error={vitalErrors.pre}
              disabled={vitalLocked}
              helperText={vitalErrors.pre ? 'Use sys/dia format' : ' '} />
          </Grid>
          <Grid item xs={6} sm={4} md={4} size={4}>
            <TextField fullWidth size="small" label="SpO₂ (%)"
              type="number" value={vitalData.spo2}
              onChange={(e) => setVitalData({ ...vitalData, spo2: e.target.value })}
              error={vitalErrors.spo2}
              disabled={vitalLocked}
              helperText={vitalErrors.spo2 ? '70–100 %' : ' '} />
          </Grid>
          <Grid item xs={6} sm={4} md={4} size={4}>
            <TextField fullWidth size="small" label="Weight (kg)"
              type="number" value={vitalData.we}
              onChange={(e) => {
                const we = e.target.value;
                setVitalData({ ...vitalData, we, bmi: calculateBMI(we, vitalData.high) });
              }}
              error={vitalErrors.we}
              disabled={vitalLocked}
              helperText={vitalErrors.we ? 'Up to 500 kg' : ' '} />
          </Grid>
          <Grid item xs={6} sm={4} md={4} size={4}>
            <TextField fullWidth size="small" label="Height (cm)"
              type="number" value={vitalData.high}
              onChange={(e) => {
                const high = e.target.value;
                setVitalData({ ...vitalData, high, bmi: calculateBMI(vitalData.we, high) });
              }}
              disabled={vitalLocked} />
          </Grid>
          <Grid item xs={6} sm={4} md={4} size={4}>
            <TextField fullWidth size="small" label="BMI"
              value={vitalData.bmi}
              InputProps={{ readOnly: true }}
              sx={{ '& .MuiInputBase-input': { bgcolor: '#f8fafc' } }} />
          </Grid>
        </Grid>

        <Box sx={{ mt: 1.25, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button variant="outlined" size="small" onClick={handleClearVitals}
            sx={{ textTransform: 'none', borderColor: '#cbd5e1', color: '#475569' }}>
            Clear
          </Button>
          <Button variant="contained" size="small" onClick={handleSaveVitals}
            disabled={vitalLocked}
            startIcon={vitalLocked ? <LockIcon sx={{ fontSize: 16 }} /> : <MonitorHeartIcon sx={{ fontSize: 16 }} />}
            sx={{ bgcolor: '#1A9B7F', textTransform: 'none', fontWeight: 700,
                  '&:hover': { bgcolor: '#157763' } }}>
            {vitalLocked ? 'Locked' : (selectedVital ? 'Update Vitals' : 'Save Vitals')}
          </Button>
        </Box>
      </Paper>
        );
      })()}

      {/* Backfill: per-day vitals entry so nurses can add missing past-day
          records without leaving the tab. Required after the doctor's
          discharge attempt raises a compliance follow-up. */}
      <ComplianceVitalsBackfill
        patient={{
          id: selectedPatient.id,
          fullName: selectedPatient.fullName,
          age: selectedPatient.age,
          gender: selectedPatient.gender,
          insurance: selectedPatient.insurance,
        }}
        admissionDate={selectedPatient.admissionDate || selectedPatient.visitDate || ''}
        currentUser={currentUser}
        vitalsHistory={vitalsHistory}
        onSaved={() => {
          loadVitalsHistory();
          setComplianceRefreshKey(k => k + 1);
        }}
      />
    </Grid>
  </Grid>
)}

{/* Blood Sugar Monitoring */}
{activeTab === 4 && (
  <Box>
    {/* Sub-tabs for FBS and RBS */}
    <Tabs
      value={bloodSugarTab}
      onChange={(e, v) => setBloodSugarTab(v)}
      sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
    >
      <Tab label="🍬 Fasting Blood Sugar (FBS)" />
      <Tab label="🍭 Random Blood Sugar (RBS)" />
    </Tabs>

    {/* FBS Tab */}
    {bloodSugarTab === 0 && (
      <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
        {/* FBS History (Left Side) */}
        <Grid item xs={12} md={5} size={4}>
          <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3, height: 600, display: 'flex', flexDirection: 'column' }}>
            <Typography variant="subtitle2" gutterBottom fontWeight="bold" sx={{ mb: 2, flexShrink: 0 }}>
              FBS History
            </Typography>

            {fbsHistory.length === 0 ? (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Science sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
                <Typography variant="body2" color="text.secondary">
                  No FBS records yet
                </Typography>
              </Box>
            ) : (
              <Box 
                sx={{ 
                  flex: 1,
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  pr: 1,
                  '&::-webkit-scrollbar': {
                    width: '8px',
                  },
                  '&::-webkit-scrollbar-track': {
                    backgroundColor: '#f1f1f1',
                    borderRadius: '10px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#888',
                    borderRadius: '10px',
                    '&:hover': {
                      backgroundColor: '#555',
                    }
                  }
                }}
              >
                {fbsHistory.map((fbs, idx) => {
                  const fbsValue = Number(fbs.FBS);
                  let statusColor = 'success';
                  let statusText = 'Normal';
                  
                  if (fbsValue < 3.9) {
                    statusColor = 'error';
                    statusText = 'Low';
                  } else if (fbsValue >= 3.9 && fbsValue <= 5.6) {
                    statusColor = 'success';
                    statusText = 'Normal';
                  } else if (fbsValue > 5.6 && fbsValue < 7.0) {
                    statusColor = 'warning';
                    statusText = 'Pre-diabetic';
                  } else {
                    statusColor = 'error';
                    statusText = 'High';
                  }

                  return (
                    <Card
                      key={idx}
                      sx={{
                        mb: 2,
                        border: selectedFbs?.trans_code === fbs.trans_code ? '2px solid' : '1px solid',
                        borderColor: selectedFbs?.trans_code === fbs.trans_code ? 'primary.main' : 'divider',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        bgcolor: fbs.dat === currentDate ? 'info.lighter' : 'background.paper',
                        '&:hover': {
                          boxShadow: 3,
                          transform: 'translateY(-2px)'
                        }
                      }}
                      onClick={() => handleSelectFbs(fbs)}
                    >
                      <CardContent sx={{ p: 2 }}>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                          <Typography variant="subtitle2" fontWeight="bold" color="primary">
                            {fbs.dat}
                            {fbs.dat === currentDate && (
                              <Chip
                                label="Today"
                                color="info"
                                size="small"
                                sx={{ ml: 1, fontSize: '0.65rem', height: 20 }}
                              />
                            )}
                          </Typography>
                          <Chip
                            size="small"
                            label={fbs.time}
                            color="default"
                            sx={{ fontSize: '0.7rem' }}
                          />
                        </Box>

                        <Box sx={{ mt: 1, p: 1.5, bgcolor: `${statusColor}.lighter`, borderRadius: 1 }}>
                          <Typography variant="h5" fontWeight={700} color={`${statusColor}.dark`}>
                            {fbs.FBS} mmol/L
                          </Typography>
                          <Chip
                            label={statusText}
                            color={statusColor}
                            size="small"
                            sx={{ mt: 0.5, fontSize: '0.7rem' }}
                          />
                        </Box>

                        {fbs.remark && (
                          <Typography variant="caption" display="block" sx={{ mt: 1, fontStyle: 'italic' }}>
                            📝 {fbs.remark}
                          </Typography>
                        )}

                        <Box display="flex" gap={1} mt={1}>
                          <IconButton
                            size="small"
                            color="error"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteFbs(fbs);
                            }}
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        </Box>
                      </CardContent>
                    </Card>
                  );
                })}
              </Box>
            )}
          </Paper>
        </Grid>

        {/* FBS Entry Form (Right Side) */}
        <Grid item xs={12} md={7} size={8}>
          <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 3, minHeight: 500 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
              <Typography variant="h6" fontWeight="bold">
                {selectedFbs ? '✏️ Edit FBS Record' : '📝 New FBS Record'}
              </Typography>
              
              {selectedFbs && (
                <Chip
                  label={`${selectedFbs.dat} ${selectedFbs.time}`}
                  color="info"
                  size="small"
                />
              )}
            </Box>

            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Fasting Blood Sugar (FBS) *"
                  type="number"
                  value={fbsData.fbs}
                  onChange={(e) => {
                    setFbsData(prev => ({ ...prev, fbs: e.target.value }));
                    if (e.target.value) setFbsError(false);
                  }}
                  error={fbsError}
                  helperText={
                    fbsError 
                      ? "Required. Valid range: 2.2-33.3 mmol/L" 
                      : "Normal: 3.9-5.6 mmol/L | Pre-diabetic: 5.6-6.9 mmol/L"
                  }
                  InputProps={{
                    startAdornment: <Box sx={{ mr: 1 }}>🍬</Box>,
                    endAdornment: <Typography variant="body2" color="text.secondary">mmol/L</Typography>
                  }}
                  inputProps={{
                    step: 0.1,
                    min: 0
                  }}
                  sx={{ 
                    '& .MuiOutlinedInput-root': {
                      fontSize: '1.2rem',
                      fontWeight: 600
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Remarks / Notes"
                  multiline
                  rows={4}
                  value={fbsData.remark}
                  onChange={(e) => setFbsData(prev => ({ ...prev, remark: e.target.value }))}
                  placeholder="Enter any observations, patient symptoms, or additional notes..."
                  helperText="Optional - Document any relevant observations"
                />
              </Grid>
            </Grid>

            <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 3 }}>
              <Button
                variant="outlined"
                color="secondary"
                startIcon={<Close />}
                onClick={handleClearFbs}
              >
                Clear
              </Button>
              
              <Button
                variant="contained"
                color="primary"
                startIcon={<SaveIcon />}
                onClick={handleSaveFbs}
              >
                {selectedFbs ? 'Update FBS' : 'Save FBS'}
              </Button>
            </Stack>

            <Box sx={{ mt: 3, p: 2, bgcolor: 'info.lighter', borderRadius: 1 }}>
              <Typography variant="caption" color="text.secondary">
                <strong>📌 Reference Ranges (mmol/L):</strong><br />
                • Normal: 3.9-5.6 mmol/L<br />
                • Pre-diabetic: 5.6-6.9 mmol/L<br />
                • Diabetic: ≥ 7.0 mmol/L<br />
                • Low (Hypoglycemia): &lt; 3.9 mmol/L
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    )}

    {/* RBS Tab */}
    {bloodSugarTab === 1 && (
      <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
        {/* RBS History (Left Side) */}
        <Grid item xs={12} md={5} size={4}>
          <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3, height: 600, display: 'flex', flexDirection: 'column' }}>
            <Typography variant="subtitle2" gutterBottom fontWeight="bold" sx={{ mb: 2, flexShrink: 0 }}>
              RBS History
            </Typography>

            {rbsHistory.length === 0 ? (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Science sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
                <Typography variant="body2" color="text.secondary">
                  No RBS records yet
                </Typography>
              </Box>
            ) : (
              <Box 
                sx={{ 
                  flex: 1,
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  pr: 1,
                  '&::-webkit-scrollbar': {
                    width: '8px',
                  },
                  '&::-webkit-scrollbar-track': {
                    backgroundColor: '#f1f1f1',
                    borderRadius: '10px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#888',
                    borderRadius: '10px',
                    '&:hover': {
                      backgroundColor: '#555',
                    }
                  }
                }}
              >
                {rbsHistory.map((rbs, idx) => {
                  const rbsValue = Number(rbs.RBS);
                  let statusColor = 'success';
                  let statusText = 'Normal';
                  
                  if (rbsValue < 3.9) {
                    statusColor = 'error';
                    statusText = 'Low';
                  } else if (rbsValue >= 3.9 && rbsValue < 7.8) {
                    statusColor = 'success';
                    statusText = 'Normal';
                  } else if (rbsValue >= 7.8 && rbsValue < 11.1) {
                    statusColor = 'warning';
                    statusText = 'Elevated';
                  } else {
                    statusColor = 'error';
                    statusText = 'High';
                  }

                  return (
                    <Card
                      key={idx}
                      sx={{
                        mb: 2,
                        border: selectedRbs?.trans_code === rbs.trans_code ? '2px solid' : '1px solid',
                        borderColor: selectedRbs?.trans_code === rbs.trans_code ? 'primary.main' : 'divider',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        bgcolor: rbs.dat === currentDate ? 'warning.lighter' : 'background.paper',
                        '&:hover': {
                          boxShadow: 3,
                          transform: 'translateY(-2px)'
                        }
                      }}
                      onClick={() => handleSelectRbs(rbs)}
                    >
                      <CardContent sx={{ p: 2 }}>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                          <Typography variant="subtitle2" fontWeight="bold" color="primary">
                            {rbs.dat}
                            {rbs.dat === currentDate && (
                              <Chip
                                label="Today"
                                color="warning"
                                size="small"
                                sx={{ ml: 1, fontSize: '0.65rem', height: 20 }}
                              />
                            )}
                          </Typography>
                          <Chip
                            size="small"
                            label={rbs.time}
                            color="default"
                            sx={{ fontSize: '0.7rem' }}
                          />
                        </Box>

                        <Box sx={{ mt: 1, p: 1.5, bgcolor: `${statusColor}.lighter`, borderRadius: 1 }}>
                          <Typography variant="h5" fontWeight={700} color={`${statusColor}.dark`}>
                            {rbs.RBS} mmol/L
                          </Typography>
                          <Chip
                            label={statusText}
                            color={statusColor}
                            size="small"
                            sx={{ mt: 0.5, fontSize: '0.7rem' }}
                          />
                        </Box>

                        {rbs.insulin && (
                          <Box sx={{ mt: 1, p: 1, bgcolor: 'secondary.lighter', borderRadius: 1 }}>
                            <Typography variant="caption" fontWeight={600}>
                              💉 Insulin: {rbs.insulin}
                            </Typography>
                          </Box>
                        )}

                        {rbs.remark && (
                          <Typography variant="caption" display="block" sx={{ mt: 1, fontStyle: 'italic' }}>
                            📝 {rbs.remark}
                          </Typography>
                        )}

                        <Box display="flex" gap={1} mt={1}>
                          <IconButton
                            size="small"
                            color="error"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteRbs(rbs);
                            }}
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        </Box>
                      </CardContent>
                    </Card>
                  );
                })}
              </Box>
            )}
          </Paper>
        </Grid>

        {/* RBS Entry Form (Right Side) */}
        <Grid item xs={12} md={7} size={8}>
          <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 3, minHeight: 500 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
              <Typography variant="h6" fontWeight="bold">
                {selectedRbs ? '✏️ Edit RBS Record' : '📝 New RBS Record'}
              </Typography>
              
              {selectedRbs && (
                <Chip
                  label={`${selectedRbs.dat} ${selectedRbs.time}`}
                  color="warning"
                  size="small"
                />
              )}
            </Box>

            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Random Blood Sugar (RBS) *"
                  type="number"
                  value={rbsData.rbs}
                  onChange={(e) => {
                    setRbsData(prev => ({ ...prev, rbs: e.target.value }));
                    if (e.target.value) setRbsError(false);
                  }}
                  error={rbsError}
                  helperText={
                    rbsError 
                      ? "Required. Valid range: 2.2-33.3 mmol/L" 
                      : "Normal: < 7.8 mmol/L | Elevated: 7.8-11.0 mmol/L | High: ≥ 11.1 mmol/L"
                  }
                  InputProps={{
                    startAdornment: <Box sx={{ mr: 1 }}>🍭</Box>,
                    endAdornment: <Typography variant="body2" color="text.secondary">mmol/L</Typography>
                  }}
                  inputProps={{
                    step: 0.1,
                    min: 0
                  }}
                  sx={{ 
                    '& .MuiOutlinedInput-root': {
                      fontSize: '1.2rem',
                      fontWeight: 600
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Insulin Dosage"
                  value={rbsData.insulin}
                  onChange={(e) => setRbsData(prev => ({ ...prev, insulin: e.target.value }))}
                  placeholder="e.g., 10 units, 5 IU, etc."
                  helperText="Optional - Record insulin administered"
                  InputProps={{
                    startAdornment: <Box sx={{ mr: 1 }}>💉</Box>
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Remarks / Notes"
                  multiline
                  rows={4}
                  value={rbsData.remark}
                  onChange={(e) => setRbsData(prev => ({ ...prev, remark: e.target.value }))}
                  placeholder="Enter any observations, patient symptoms, or additional notes..."
                  helperText="Optional - Document any relevant observations"
                />
              </Grid>
            </Grid>

            <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 3 }}>
              <Button
                variant="outlined"
                color="secondary"
                startIcon={<Close />}
                onClick={handleClearRbs}
              >
                Clear
              </Button>
              
              <Button
                variant="contained"
                color="primary"
                startIcon={<SaveIcon />}
                onClick={handleSaveRbs}
              >
                {selectedRbs ? 'Update RBS' : 'Save RBS'}
              </Button>
            </Stack>

            <Box sx={{ mt: 3, p: 2, bgcolor: 'warning.lighter', borderRadius: 1 }}>
              <Typography variant="caption" color="text.secondary">
                <strong>📌 Reference Ranges (mmol/L):</strong><br />
                • Normal: &lt; 7.8 mmol/L (2 hours post-meal)<br />
                • Elevated: 7.8-11.0 mmol/L<br />
                • Diabetic: ≥ 11.1 mmol/L<br />
                • Low (Hypoglycemia): &lt; 3.9 mmol/L
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    )}
  </Box>
)}



{/* Medication Charting Sheet */}
{activeTab === 5 && (
  <InlineMedicationSheet
    patient={selectedPatient}
    chartedMedications={chartedMedications}
    onMarkServed={handleMarkAsServed}
    onDelete={handleDeleteChartedMed}
    onChartNew={() => setMedSheetDialogOpen(true)}
    chartNewDisabled={!patientMedications || patientMedications.length === 0}
  />
)}


{activeTab === 6 && (
  <Box>
    <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
      {/* Current Bed Information */}
      <Grid item xs={12}>
        <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 3, bgcolor: 'info.lighter' }}>
          <Typography variant="h6" fontWeight={700} gutterBottom color="info.dark">
            📍 Current Bed Assignment
          </Typography>
          
          {currentBedInfo ? (
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12} sm={6} md={3}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Ward:</Typography>
                  <Typography variant="h6" fontWeight={600}>
                    {currentBedInfo.ward_name}
                  </Typography>
                </Box>
              </Grid>
              
              <Grid item xs={12} sm={6} md={3}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Bed Number:</Typography>
                  <Typography variant="h6" fontWeight={600}>
                    {currentBedInfo.bed_number}
                  </Typography>
                </Box>
              </Grid>
              
              <Grid item xs={12} sm={6} md={3}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Admission Date:</Typography>
                  <Typography variant="body1" fontWeight={500}>
                    {currentBedInfo.admission_date}
                  </Typography>
                </Box>
              </Grid>
              
              <Grid item xs={12} sm={6} md={3}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Admission Time:</Typography>
                  <Typography variant="body1" fontWeight={500}>
                    {currentBedInfo.admission_time}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          ) : (
            <Box sx={{ textAlign: 'center', py: 3 }}>
              <Hotel sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
              <Typography variant="body1" color="text.secondary">
                Patient not currently assigned to any bed
              </Typography>
            </Box>
          )}

          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<PersonAdd />}
              onClick={handleOpenTransferDialog}
              disabled={!currentBedInfo}
            >
              Transfer Patient
            </Button>
          </Box>
        </Paper>
      </Grid>
    </Grid>

   

  </Box>
)}

</Paper>
  </Box>
) : (
  <Paper
    sx={{
      p: 6,
      textAlign: "center",
      height: "60vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Box>
      <Person sx={{ fontSize: 80, color: "text.secondary", mb: 2 }} />
      <Typography variant="h6" color="text.secondary">
        Search and select a patient to begin consultation
      </Typography>
    </Box>
  </Paper>
)}


{/* Chart Medication Dialog — extracted to MedicationChartDialog */}

<MedicationChartDialog
  open={medSheetDialogOpen}
  onClose={() => { setMedSheetDialogOpen(false); }}
  patient={selectedPatient}
  medications={patientMedications}
  chartedMedications={chartedMedications}
  currentUser={currentUser}
  onSaved={async () => {
    await loadChartedMedications();
    await loadPatientMedicationsForChart();
  }}
/>




 {/* Transfer Dialog */}
    
  <Dialog
    open={transferDialogOpen}
    onClose={() => setTransferDialogOpen(false)}
    maxWidth="lg"
    fullWidth
  >
    {/* Header */}
    <DialogTitle
      sx={{
        background: 'linear-gradient(135deg, #178826ff, #2e5f23ff)',
        color: 'white',
        pb: 3
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography variant="h5" fontWeight={700}>
            🔄 Ward Transfer
          </Typography>
          <Typography variant="body2">
            Transfer {selectedPatient?.fullName} to another ward
          </Typography>
        </Box>
        <IconButton onClick={() => setTransferDialogOpen(false)} sx={{ color: 'white' }}>
          <Close />
        </IconButton>
      </Stack>
    </DialogTitle>

    <DialogContent sx={{ pt: 4 }}>
      {/* Current Bed Info */}
      <Paper sx={{ p: 3, mb: 4 ,mt:2, bgcolor: 'info.50', borderLeft: '5px solid #1976d2' }}>
        <Typography fontWeight={700} gutterBottom>
          📍 Current Location
        </Typography>
        <Typography>
          Ward: <b>{currentBedInfo?.ward_name}</b>
        </Typography>
        <Typography>
          Bed: <b>{currentBedInfo?.bed_number}</b>
        </Typography>
      </Paper>

      {/* Step 1: Select Ward */}
      <Typography variant="h6" fontWeight={700} gutterBottom>
        🏥 Step 1: Select New Ward
      </Typography>
      <FormControl fullWidth sx={{ mb: 3 }}>
        <InputLabel>Select Ward</InputLabel>
        <Select
          value={selectedWard || ''}
          label="Select Ward"
          onChange={(e) => handleWardSelect(e.target.value)}
        >
          {wards.map((w) => (
            <MenuItem key={w.id} value={w.id}>
              {w.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Step 2: Select Bed */}
      {selectedWard && (
        <>
          <Typography variant="h6" fontWeight={700} gutterBottom>
            🛏️ Step 2: Select Available Bed
          </Typography>

          {availableBeds.length === 0 ? (
            <Paper sx={{ p: 3, textAlign: 'center', bgcolor: 'grey.100' }}>
              No available beds in this ward
            </Paper>
          ) : (
            <Grid container spacing={2}>
              {availableBeds.map((bed) => (
                <Grid item xs={6} sm={4} md={3} key={bed.bed_id}>
                 <Paper
                  onClick={() => setSelectedBed(bed.bed_id)}
                  elevation={selectedBed === bed.id ? 8 : 2}
                  sx={{
                    p: 3,
                    textAlign: "center",
                    cursor: "pointer",
                    bgcolor: selectedBed === bed.bed_id ? "success.main" : "white",
                    color: selectedBed === bed.bed_id ? "white" : "text.primary",
                    border: "2px solid",
                    borderColor: selectedBed === bed.bed_id ? "success.dark" : "grey.300",
                    transition: "all 0.25s ease",
                    "&:hover": {
                      transform: "translateY(-6px)",
                      boxShadow: 6,
                      borderColor: "success.main",
                    },
                  }}
                >
                  <Hotel sx={{ fontSize: 40, mb: 1 }} />
                  <Typography variant="h6" fontWeight={700}>
                    {bed.bed_number}
                  </Typography>
                  <Typography variant="caption">
                    {selectedBed === bed.bed_id? "✓ Selected" : "Available"}
                  </Typography>
                </Paper>

                </Grid>
              ))}
            </Grid>
          )}
        </>
      )}

      {/* Transfer Reason */}
      <TextField
        fullWidth
        multiline
        rows={4}
        label="Transfer Reason *"
        value={transferReason}
        onChange={(e) => setTransferReason(e.target.value)}
        sx={{ mt: 4 }}
      />
    </DialogContent>

    <DialogActions sx={{ p: 3 }}>
      <Button onClick={() => setTransferDialogOpen(false)}>Cancel</Button>
      <Button
        variant="contained"
        startIcon={<LocalHospital />}
        disabled={!selectedBed || !transferReason}
        onClick={handleTransferPatient}
      >
        Confirm Transfer
      </Button>
    </DialogActions>
  </Dialog>


<MedicalHistoryDialog
  open={medHistoryOpen}
  onClose={() => setMedHistoryOpen(false)}
  patientData={selectedPatient}
/>

<LabHistoryDialog
  open={labHistoryOpen}
  onClose={() => setlabHistoryOpen(false)}
  patientData={selectedPatient}
/>

<ScanHistoryDialog
  open={ScanHistoryOpen}
  onClose={() => setScanHistoryOpen(false)}
  patientData={selectedPatient}
/>

<VitalsHistoryDialog
  open={vitalsHistoryOpen}
  onClose={() => setVitalsHistoryOpen(false)}
  patientData={selectedPatient}
/>

<MedicationHistory
    open={openmedHis}
    onClose={() => setopenmedHis(false)}
    id={selectedPatient ? selectedPatient.id: ''}
  />

 <SpecialPrecautionDialog
  open={precautionDialogOpen}
  onClose={() => setPrecautionDialogOpen(false)}
  patient={selectedPatient}
/>


 <VitalsHistoryDialogAdmission
      open={VitalsHistoryOpennow}
      onClose={() => setVitalsHistoryOpennow(false)}
      patientData={selectedPatient}
      startDate={selectedPatient ? selectedPatient.visitDate :''}
    />

    <LabHistoryDialogAdmission
    open={labHistoryOpennow}
    onClose={() => setlabHistoryOpennow(false)}
    patientData={selectedPatient}
    sendstartDate={selectedPatient ? selectedPatient.visitDate :''}
  />

  
  <ScanHistoryDialogAdmission
    open={ScanHistoryOpennow}
    onClose={() => setScanHistoryOpennow(false)}
    patientData={selectedPatient}
    sendstartDate={selectedPatient ? selectedPatient.visitDate :''}
  />

  
    <MedicalHistoryDialogAdmission
      open={openmedHisnow}
      onClose={() => setopenmedHisnow(false)}
      id={selectedPatient ? selectedPatient.id: ''}
      sendstartDate={selectedPatient ? selectedPatient.visitDate :''}
    />

   <MedicationSheetDialog
        open={medSheetOpen}
        onClose={() => setMedSheetOpen(false)}
        patientData={selectedPatient}
        startDate={selectedPatient?.visitDate}
      />

        </>
        )}
</Container>
</Box>
  );
};

export default InPatient;
